var CUSOMIZATION_BASE_URL = "https://personaly-meinekette-custom.de";
// var CUSOMIZATION_BASE_URL = "http://127.0.0.1:8000";

var PCO_VALUES = {}
// var PCO_VALUES = {}
var PCO_OPTIONS = [];
var PCO_DATA = false
var PCO_IMAGES = {};
var PCO_VARIANTS = [];
var PCO_FONTS = {};
var sort = []
var PCO_VALUES_REF = {
    logo_inside: true
}
var PCO_VARIANT_OPTIONS = [];
var PCO_DYNAMIC_VARIANTS = [];
var PCO_ACTIVE_IMAGES = [];
var PCO_NAME_FILTER_TYPES = {}
var PCO_VARIANT_CONNECTIONS = {}
var PCO_PRICING_REF = {}

var PCO_NAME_TYPES = {}
// var updateTimeout;

function randomStr(len = 10, arr = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ") {
    let ans = '';
    for (let i = len; i > 0; i--) {
        ans += arr[(Math.floor(Math.random() * arr.length))];
    }
    return ans
}


if (typeof debounce === 'undefined') {
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
}
var PCO_VALUES = new Proxy(PCO_VALUES_REF, {
    set(target, property, value) {
        target[property] = value;
        updatePriceImage()
        if(value?.type == "color" || value?.type == "metal"){
            const event = new CustomEvent('PCO_VALUES_CHANGED.color_metal', {
                detail: target
            });
            document.dispatchEvent(event);
        }
        const allEvent = new CustomEvent('PCO_VALUES_CHANGED', {
            detail: { property, target }
        });
        const event = new CustomEvent('PCO_VALUES_CHANGED.'+property, {
            detail: { property, value }
        });
        document.dispatchEvent(event);
        document.dispatchEvent(allEvent);

        return true;
    }
});

var setNameValSort = (name, item, type) => {
    if (!item?.is_variant) {
        return;
    }
    // if (item?.has_image && !sort?.includes(name)) {
    if (item?.is_variant && !sort?.includes(name)) {
        sort.push(name)
    }
    let val = PCO_VALUES?.[name]
    if(PCO_NAME_FILTER_TYPES[name]){
        const val_label = item?.value ?? item?.label
        if(PCO_NAME_FILTER_TYPES[name] == val_label){
            val = false;
        }
    }
    if (!val) {
        val = item
        if(!item?.type && type){
            item.type = type
        }
        PCO_VALUES[name] = item
    }
    return val?.id
}

var image_choice_list = (option, name, active) => {
    const $container = $('<div>', { class: 'item-additional-content' });

    const $qualityContainer = $('<div>', { class: 'item-quality-container' }).append($('<div>', { class: 'quality-container' }));

    if (option?.list?.label) {
        const $qualityStoneLabel = $('<div>', { class: 'quality-stone-label' })
        .append(
            $('<span>').append(
                $('<span>').text(option.list.label)
            )
        );
        $qualityContainer.find('.quality-container').append($qualityStoneLabel);
    }

    const $qualityOptions = $('<ul>', { class: 'quality-options' });

    var prev_active = {}

    let stone_type_count = [];

    if (option?.list) {
        option.list.map(item => {
            const val = setNameValSort(name, item);
            if(item?.is_stone){
                stone_type_count.push(item)
            }

            const $qualityItem = $('<li>', {
                class: `quality-item pco-variant-option ${item?.has_image ? 'has-preview-image' : ''} ${val == item?.id ? 'active' : ''}`,
                'data-name': name,
                'data-id': item?.id,
                'data-price': item?.price
            });

            const $img = $('<img>', {
                class: 'quality_image_view',
                loading: 'lazy',
                'data-csrc': item?.icon
            });

            const $label = $('<span>', { class: 'label' })
                .append(
                    $('<label>').append(
                        $('<span>', { class: 'quality-label' }).text(item?.label)
                    )
                );

            if (item?.sublabel) {
                $label.append(
                    $('<span>', { class: 'quality-additional-label' }).text(item.sublabel)
                );
            }

            const $priceCompare = $('<div class="pco-price-compare"><div>')
            const update = (value) => {
                let up_text = ""
                if(value?.id != item?.id){
                    let comp_price = parseFloat(value?.price ?? 0) - parseFloat(item?.price ?? 0);
                    if(comp_price != 0){
                        if(comp_price < 0){
                            $priceCompare.addClass("increase")
                        }else {
                            $priceCompare.removeClass("increase")
                        }
                        comp_price = comp_price > 0 ? '-'+comp_price : "+"+(-comp_price);
                        up_text = comp_price+" €";
                    }
                }
                $priceCompare.text(up_text)
                if(item?.is_variant){
                    if(value?.id == item?.id){
                        $qualityItem.addClass("active")
                    }else{
                        $qualityItem.removeClass("active")
                    }
                }
                prev_active = value
            }
            update(PCO_VALUES[name])

            document.addEventListener('PCO_VALUES_CHANGED.'+name, function(e) {
                const { _, value } = e.detail;
                update(value)
            })

            $qualityItem.append($img).append($label).append($priceCompare);
            $qualityOptions.append($qualityItem);
        });
    }

    $qualityContainer.find('.quality-container').append($qualityOptions);

    const $qualityMediaInfo = $('<div>', { class: 'quality-media-info' })
        // .append(
        //     $('<div>', { class: 'view-video-3d' }).append(
        //         $('<span>').text('3D View - II')
        //     )
        // )
        // .append(
        //     $('<div>', { class: 'view-comparison-chart' }).append(
        //         $('<span>').text('Compare quality options')
        //     )
        // );
    if(stone_type_count.length > 0){

        const open = () => {
            const $modalContents = $(`<div class='quality-compare-container'>
                <div class="quality_diamond_brillant_content">
                    <div class="quality_stone_revisions_last quality_stone_revisions">
                        <div class="quality_stone_revisions_titlemb">
                        </div>
                        <div class="quality_stone_revisions_data"></div>
                    </div>
                </div>
            </div>`)

            const $tabs = $modalContents.find(".quality_stone_revisions_titlemb")
            const $tabContents = $modalContents.find(".quality_stone_revisions_data")

            stone_type_count?.forEach((item, idx) => {
                const $tab = $(`<div class="quality_stone_titlemb ${idx == 0 ? "active" : ""}"><span>${item?.label}</span></div>`)
                const $tabContent = $(`<div class="quality_stone_div ${idx == 0 ? "active" : ""}">
                    <div class="quality_stone_image a quality-image-content">
                        <span>${item?.label}</span> 
                        <img alt="${item?.label}" loading="lazy" src="${item?.icon}">
                    </div>
                    <div class="quality_stone_content_rs">
                        ${item?.stone_color ? 
                            `<div>
                                <span class="title">Farbe:</span>
                                <p>${item?.stone_color}</p>
                            </div>`: ""
                        }
                        ${item?.stone_clarity ? 
                            `<div>
                                <span class="title">Klarheit:</span>
                                <p>${item?.stone_clarity}</p>
                            </div>`: ""
                        }
                        ${item?.stone_cut ? 
                            `<div>
                                <span class="title">Schliff:</span>
                                <p>${item?.stone_cut}</p>
                            </div>`: ""
                        }

                        ${item?.stone_description ? 
                            `<div>
                                <span class="title">Charakterisierung:</span>
                                <p>${item?.stone_description}</p>
                            </div>`: ""
                        }
                    </div>
                </div>`)

                $tabs.append($tab)
                $tabContents.append($tabContent)

                $tab.on("click", function() {
                    $tabs.children(".quality_stone_titlemb").removeClass("active")
                    $tabContents.children(".quality_stone_div").removeClass("active")
                    $tabContent.addClass("active")
                    $tab.addClass("active")
                })

            })

            const { closeFunc } = modalItem("DIAMANT Qualitätsoptionen", $modalContents, false, "modal-quality-comparison modal-mobile-swipe modal-lg")
        }

        const $comparison = $('<div class="view-comparison-chart"><span>Qualitätsoptionen vergleichen</span></div>')
        $qualityMediaInfo.append($comparison);
        $comparison.on("click", function() {
            open()
        })
    }

    $qualityContainer.find('.quality-container').append($qualityMediaInfo);

    $container.append($qualityContainer);

    return $container;
};


var PCO_COLOR_NAMES_COUNT = 0;
var color_choice_list = (option, name, active) => {
    name = PCO_VALUES[option?.label] ? option?.label + " " + PCO_COLOR_NAMES_COUNT : option?.label;
    var has_variant_connection = false
    if(option?.variant_connected && option?.variant_field_name){
        const $fiedlset = $(`fieldset[data-variant-option-name="${option?.variant_field_name}"]`)
        if($fiedlset.length > 0){
            $fiedlset.addClass("hide")
            has_variant_connection = true;
            PCO_VARIANT_CONNECTIONS[name] = true;
        }
    }

    const $colorList = $('<ul>', { class: 'option-colour-list' });
    var prev_active = {}
    PCO_NAME_TYPES[name] = "color";

    const options_available = {}
    if(has_variant_connection){
        let index = customizer_product?.product?.options?.findIndex((item) => item == name)
        if(index > -1){
            index = index+1 
        }
        customizer_product.product?.variants?.forEach((variant) => {
            options_available[variant?.['option'+index]] = true;
        })
    }

    if (option?.list) {
        option.list.map((item, idx) => {

            if(!options_available[item?.label]){
                return;
            }
            
            // const val = setNameValSort(name, item);
            const val = setNameValSort(name, {...item, type: "color"});
            const valText = (item?.value ?? item?.label)
            const is_disabled = $(`variant-selects [name="${option?.variant_field_name}"][value="${valText}"]`)?.hasClass("is-diabled")

            const $colorItem = $('<li>', {
                class: `color-item pco-variant-option ${has_variant_connection ? "has-variant-connection" : ""} ${item?.has_image ? 'has-preview-image' : ''} ${is_disabled ? "is-disabled" : ""} ${item?.id == val ? 'active' : ''}`,
                'data-engraving-preview': item?.engraving_preview,
                'data-name': name,
                'data-type': "color",
                'data-value': valText,
                'data-variant-option': option?.variant_field_name, 
                'data-id': item?.id,
                'data-price': item?.price
            });

            const $img = $('<img>', {
                src: item?.icon,
                alt: item?.label,
                loading: 'lazy',
                class: 'imageView',
                width: 49,
                height: 49
            });

            const $priceCompare = $('<div class="pco-price-compare"><div>')
            const update = (value, first) => {
                let up_text = ""
                if(value?.id != item?.id){
                    let comp_price = parseFloat(value?.price ?? 0) - parseFloat(item?.price ?? 0);
                    if(comp_price != 0){
                        if(comp_price > 0){
                            $priceCompare.addClass("increase")
                        }else {
                            $priceCompare.removeClass("increase")
                        }
                        comp_price = comp_price > 0 ? '+'+comp_price : comp_price;
                        up_text = comp_price+" €";
                    }
                }
                $priceCompare.text(up_text)

                if(item?.is_variant){
                    if(value?.id == item?.id){
                        $colorItem.addClass("active")

                        if(!first){
                            const $fiedlset = $(`fieldset[data-variant-option-name="${name}"]`)
                            $fiedlset.find(`input[name="${name}"]`).prop("checked", false)
                            const el = $fiedlset.find(`input[name="${name}"][value="${valText}"]`)
                            el.prop("checked", true)
                            $fiedlset.closest('variant-selects')[0].onVariantChange({target: el[0]})
                        }
                    }else {
                        $colorItem.removeClass("active")
                    }
                }
                prev_active = value
            }
            update(PCO_VALUES[name], true)

            document.addEventListener('PCO_VALUES_CHANGED.'+name, function(e) {
                const { property, value } = e.detail;
                update(value)
            })

            $colorItem.append($img);
            $colorItem.append($priceCompare);
            $colorList.append($colorItem);
        });
    }

    return $colorList;
};


var choice_list_items = (option, name, active, is_metal) => {
    if (!option?.list?.length) return "";
    const $list =  $('<ul>', { class: 'option-list' });
    
    var prev_active = {}

    option.list.map((item, idx) => {
        const isVariantItem = !item?.list || (item?.list?.length == 0 && item?.is_variant);
        const variant_item = isVariantItem ? item : item?.list?.[0];
        const val = setNameValSort(name, {...item, ...(is_metal ? {type: "metal"} : {})});
        if(is_metal){
            PCO_NAME_TYPES[name] = "metal";
        }

        const $listItem = $('<li>', {
            class: `item choice ${variant_item?.has_image ? 'has-preview-image' : ''} ${variant_item ? 'pco-variant-option-choice' : ''} ${val == item?.id || (idx == 0 && active) ? 'active' : ''}`,
            ...(variant_item && {
                'data-name': name,
                'data-id': variant_item?.id,
                ...(is_metal ? { 'data-type': 'metal' } : {}),
                'data-price': variant_item?.price
            })
        });

        const $itemContent = $(`<div class="item-content">
            <span class="item-label">
                <span class="label">${item?.label}</span>
                ${item?.icon ? `<img data-csrc="${item?.icon}" />`:""}
            </span>
        </div>`)

        if(item?.popover){
            const $popup = $(`<span data-toggle="popover" class="enable-popover"><span class="help_icon target-icon">[?] </span></span>`);
            popoverItem($popup, item?.popover)
            $itemContent.children(".item-label").append($popup)
        }

        const listIDS = item?.is_variant ? [item?.id] : item?.list?.map((obj) => {return obj.id})

        if(variant_item){
            const $priceCompare = $('<div class="pco-price-compare"><div>')
            const update = (value) => {
                let up_text = ""
                if(value?.id != variant_item?.id && (item?.is_variant || !listIDS?.includes(value?.id))){
                    let comp_price = (value?.price ?? 0) - (variant_item?.price ?? 0);
                    if(comp_price != 0){
                        if(comp_price > 0){
                            $priceCompare.removeClass("increase")
                        }else {
                            $priceCompare.addClass("increase")
                        }
                        comp_price = comp_price > 0 ? -comp_price : "+"+(-comp_price);
                        up_text = comp_price+" €";
                    }
                }
                $priceCompare.text(up_text)
                
                // if(item?.is_variant){
                if(value?.id == variant_item?.id || listIDS?.includes(value?.id)){
                    $listItem.addClass("active")
                    if(!item?.is_variant){
                        $listItem.find(`img[data-csrc]`).each(function() {
                            $(this).attr("src", $(this).attr('data-csrc')).removeAttr("data-csrc")
                        })
                    }
                }else{
                    $listItem.removeClass("active")
                }
                // }
                prev_active = value
            }
            update(PCO_VALUES[name])

            document.addEventListener('PCO_VALUES_CHANGED.'+name, function(e) {
                const { property, value } = e.detail;
                update(value)
            })
            $itemContent.children("span").append($priceCompare)
        }
        $listItem.append($itemContent).append(render_item(item, name, active));
        $list.append($listItem)
    });

    return $list;
};

var initilize_fonts = (fonts) => {
    fonts?.forEach((font) => {
        let font_name = font?.url?.split("/").at(-1)
        font_name = font_name?.split(".")[0]
        font_name = decodeURIComponent(font_name);
        if (!PCO_FONTS[font_name]) {
            const fontFace = new FontFace(font_name, `url(${font?.url})`);
            fontFace.load().then(loadedFontFace => {
                document.fonts.add(loadedFontFace);
            }).catch(error => {
                console.error('FontFace loading failed:', error);
            });
        }
    })
}

var engrave_svg_text = (text, font) => {
    return customizer_product?.type == "necklace" ?
        `<div class="engraving-preview-content text-path-el" style="text-align: center; position: relative; top: 50%;font-size: 40px; font-weight: bold; overflow: hidden; color: rgb(0, 0, 0); white-space: nowrap;"></div>` : 
        (`<svg viewBox="0 0 325 50" fill="transparent" style="font-family:${font}">
        <path id="curve1" d="M 0 45 Q 162.5 0 325 37" fill="none"></path>
        <path id="curve2" d="M 0 48 Q 162.5 0 325 40" fill="none"></path>
        <text fill="#000" fill-opacity="0.8" class="layer1">
            <textPath xlink:href="#curve1" startOffset="50%" text-anchor="middle" class="text-path-el">${text}</textPath>
        </text>
        <text fill="#fff" fill-opacity="0.4" class="layer2">
            <textPath xlink:href="#curve2" startOffset="50%" class="text-path-el" text-anchor="middle">${text}</textPath>
        </text>
    </svg>`)
}

var show__hide_fonts__ = customizer_product?.product?.tags?.includes("namenskette") || customizer_product?.product?.tags?.includes("namensarmband")
var DEF_FONT_ENGRAVING_OPTION = {
    "fonts": [
        {"label":"", "id": 20006, "url": "https://personaly-meinekette-custom.de/fonts/AlexBrush-Regular.ttf"},
        ...(show__hide_fonts__ ? [{"label":"", "id": 20002, "url": "https://personaly-meinekette-custom.de/fonts/Brush%20Script%20Regular.ttf"}] : []),
        {"id": 20003, "url":"https://personaly-meinekette-custom.de/fonts/CENTURY.ttf"},
        // {"id": 20004, "url":"https://personaly-meinekette-custom.de/fonts/GreatVibes.ttf"},
        {"id": 20005, "url":"https://personaly-meinekette-custom.de/fonts/Italianno-Regular.ttf"},
        {"id": 20005, "url":"https://personaly-meinekette-custom.de/fonts/MonotypeCorsiva.ttf"},
        ...(show__hide_fonts__ ? [{"id": 20005, "url":"https://personaly-meinekette-custom.de/fonts/Notera.ttf"}] : []),
    ],
    "symbols": [
        {"icon": "♥", "id": 1001},
        {"icon": "♡", "id": 1002},
        {"icon": "∞", "id": 1003},
        {"icon": "☆", "id": 1004},
        {"icon": "☘", "id": 1005},
        {"icon": "⚭", "id": 1006},
        {"icon": "&", "id": 1007}
    ]
}

var engraving_item = (engravingItem) => {

    const $engravingGroupWrapper = $("<ul class='options-list engravgin-list'></ul>")
    const generateItem = (item) => {
        const font_list = item?.fonts || DEF_FONT_ENGRAVING_OPTION.fonts
        const symbols_list = item?.symbols || DEF_FONT_ENGRAVING_OPTION.symbols
        initilize_fonts(font_list);
        let active_font = "";
    
        const $engravingGroup = $('<li>', { class: 'engraving-group' });
        if(engravingItem?.list?.length > 0){
            $engravingGroup.append(`<label class="engraving-group-label">${item?.label}</label>`)
        }
    
        if(item?.has_font_selection != 1 && font_list?.length > 0){
            const $engravingFont = $('<div>', { class: 'engraving-font' })
                .append(
                    $('<div>', { class: 'engraving-label font-label' }).append(
                        $('<span>').text(item?.choose_font_label ?? "Wählen Sie eine Schriftart")
                    )
                )
                .append(
                    $('<ul>', { class: 'option-list font-list' }).append(
                        font_list?.map((font, idx) => {
                            let font_name = font?.url?.split("/").at(-1)?.split(".")[0];
                            font_name = decodeURIComponent(font_name);
                            const is_active = PCO_VALUES["font"] == font_name || (!PCO_VALUES["font"] && idx == 0);
                            if (is_active) active_font = font_name;
        
                            return $('<li>', {
                                class: `font-item ${is_active ? 'active' : ''}`,
                                'data-font': font_name,
                                'data-id': font?.id,
                                style: `font-family:${font_name}`
                            }).append($('<span>').text('Aa'));
                        })
                    )
                );
            $engravingGroup.append($engravingFont);
        }else {
            initilize_fonts([item?.default_font]);
            let font_name = item?.default_font?.split("/").at(-1)?.split(".")[0];
            font_name = decodeURIComponent(font_name);
            active_font = font_name
        }

        item.max_len = item?.max_len ?? 25
        const f_name = "engraving__v__"+(item?.label ?? item?.name)
        const $engravingInput = $('<div>', { class: 'engraving-input' })
            .append(
                $('<div>', { class: 'engraving-label input-label' }).append(
                    $('<span class="engraving-label-input-title">').text(item?.text_field_label ?? "Innengravur"),
                    item?.max_len ? $('<span>', { class: 'engraving-text-left' }).html(`<span class="pco-char-count">0</span>/${item?.max_len} Symbole`) : null
                )
            )
            .append(
                $('<div>', { class: 'engraving-option text-option' }).append(
                    $('<div>', { class: 'engraving-input-wrapper' }).append(
                        $('<input>', {
                            class: 'engraving-input-field '+(item?.is_required ? "pco-is-required" : ""),
                            ...(item?.max_len && { 'data-max': item?.max_len }),
                            'data-name': f_name,
                            'data-id': item?.id,
                            'data-font': active_font,
                            placeholder: item?.text_placeholder
                        })
                    ),
                    item?.is_required && $(`<div data-name="${f_name}" class="warning-message-inp"></div>`)
                )
            );
    
        if (symbols_list?.length > 0 && item?.has_custom_symbols == 2) {
            const $engravingSymbols = $('<div>', { class: 'engraving-symbols' }).append(
                symbols_list?.map(symbol => {
                    return $('<span>', {
                        class: 'symbol-item',
                        'data-icon': symbol?.icon,
                        'data-id': symbol?.id
                    }).append($('<span>').text(symbol?.icon));
                })
            );
            $engravingInput.append($engravingSymbols);
        }
    
        $engravingInput.append($('<div>', { class: 'error-message' }));
        $engravingGroup.append($engravingInput);
    
        const $engravingPreview = $('<div>', { class: 'engraving-preview engraving-inside' })
            .append(
                $('<div>', { class: 'engraving-preview-content' }).append(
                    engrave_svg_text("", active_font)
                )
            );
    
        $engravingGroup.append($engravingPreview);

        $engravingGroupWrapper.append($engravingGroup)
    }

    engravingItem?.list?.forEach((item) => {
        generateItem(item)
    })

    return $engravingGroupWrapper;
};
var box_item = (box_item, name) => {
    const $boxOptions = $('<div>', { class: 'pco-box-options' });

    const $optionList = $('<div>', { class: 'option-list' });

    var prev_active = {}
    
    if (box_item?.list) {
        box_item.list.map((item, idx) => {
            const val = setNameValSort(name, item);

            const $choice = $('<div>', {
                class: `item choice pco-variant-option ${item?.has_image ? 'has-preview-image' : ''} ${val == item?.id ? 'active' : ''}`,
                'data-id': item?.id,
                'data-price': item?.price,
                'data-name': name
            });

            const $itemContent = $('<div>', { class: 'item-content item-label' }).append(
                $('<span>', { class: 'item-label' }).append(
                    $('<span>', { class: 'label' }).text(item?.label),
                    item?.icon ? $('<img>', {
                        src: item?.icon,
                        alt: "A",
                        loading: 'lazy',
                        class: 'imageView',
                        width: 25,
                        height: 25
                    }) : null
                )
            );

            // if(variant_item){
                const $priceCompare = $('<div class="pco-price-compare"><div>')
                const update = (value) => {
                    let up_text = ""
                    if(value?.id != item?.id){
                        let comp_price = value?.price - item?.price;
                        if(comp_price != 0){
                            if(comp_price > 0){
                                $priceCompare.addClass("increase")
                            }else {
                                $priceCompare.removeClass("increase")
                            }
                            comp_price = comp_price > 0 ? '+'+comp_price : comp_price;
                            up_text = comp_price+" €";
                        }
                    }
                    $priceCompare.text(up_text)

                    if(item?.is_variant){
                        if(value?.id == item?.id){
                            $choice.addClass("active")
                        }else if(prev_active?.id == item?.id){
                            $choice.removeClass("active")
                        }
                    }
                    prev_active = value
                }
                update(PCO_VALUES[name])
    
                document.addEventListener('PCO_VALUES_CHANGED.'+name, function(e) {
                    const { property, value } = e.detail;
                    update(value)
                })
                $itemContent.children("span").append($priceCompare)
            // }
    

            const $additionalContent = $('<div>', { class: 'item-additional-content item-label' }).append(
                $('<div>', { class: 'item-description' }).append(
                    $('<div>', { class: 'option-description-title' }).append(
                        $('<span>').text(item?.title)
                    ),
                    $('<div>', { class: 'option-description-content' }).append(
                        $('<span>').text(item?.subtitle)
                    )
                )
            );

            $choice.append($itemContent).append($additionalContent);
            $optionList.append($choice);
        });
    }

    $boxOptions.append($optionList);
    return $boxOptions;
};

var has_additional_item = (item, name, active, direct = false) => {
    const has_collapse = item?.collapsible;
    const $container = $('<div>', {
        class: `option_group_container ${has_collapse ? 'MuiCollapse' : ''} ${active || !has_collapse == 'color' ? 'active' : ''}`
    });

    if (item?.label && (!(item?.type == "engraving" && item?.list?.length < 2) && item?.type != "size") && !direct) {
        const $label = $('<div>', {
            class: `option_group_label ${has_collapse ? 'collapse-action' : ''}`
        }).append(
            $('<div>', { class: 'label' }).text(item?.label),
            item?.icon ? $('<img>', { 'data-csrc': item?.icon }) : null,
            has_collapse ? $('<div>', { class: 'dropdown_des' }) : null
        );
        $container.append($label);
    }
    const $wrapper = $('<div>', {
        class: `${has_collapse ? 'MuiCollapse-wrapper' : ''} ${active ? 'visible' : ''}`
    }).append(
        $('<div>', { class: 'MuiCollapse-wrapperInner' }).append(
            $('<div>', { class: 'option_group_content' }).append(
                $('<ul>', { class: 'option-list' }).append(render_item(item, name, active))
            )
        )
    );

    $container.append($wrapper);
    return $container;
};

var sizeNames = {}
var bodyClickHideFunc = () => {}
var sizeOpener = {}
var size_item = (item, _, active) => {

    let name = sizeNames[item?.labe] ? item?.label+" 2" : item?.label;
    sizeNames[name] = true;
    
    PCO_VALUES[name] = {...(PCO_VALUES[name] ?? {}), type: "size"};

    const $wrapper = $(`<div class="product-options-size option-item">
        <div class="options fieldset">
            <div class="product-option option-ringsize ring_size field"></div>
        </div>
    </div>`)
    const $optionSet = $wrapper.find(".option-ringsize")

    const $labelWrapper = $(`<div class="ringsize-label ${item?.is_required ? "pco-is-required" : ""}" data-name="${name}">
        <span class="label option-label">
            <span class="option_label_title">${item?.label}: </span>
            <span class="value_selected"></span>
        </span>
    </div>`)
    const $sizeGuide = $(`<div class="footer-content">
        <span class="discover-size link active">
            Größenanleitung
        </span>
    </div>`)
    $labelWrapper.append($sizeGuide)
    $optionSet.append($labelWrapper)

    const open = () => {

        const $modalContents = $(`<div>
            <div class="size-modal-container">
                <div class="size-table-container">
                    <div class="size-table-row size-table-header">
                        <div class="title head-item">Damenringgröße</div>
                        <div class="diameter head-item">Innerer durchmesser, mm</div>
                        <div class="circumference head-item">Umfang, mm</div>
                    </div>
                    <div class="size-table-content option-list"></div>
                </div>
            </div>
            <button title="In den Warenkorb" class="action primary tocart" style="display:none" id="product-addtocart-size-button" style=""><span>In den Warenkorb</span></button>
            <div class="collapsible-list-type-2" style="display:none">
                <div class="collapsible-content__inner">
                    <collapsible-row class="accordion">
                        <details id="Details-collapsible_tab_KG6MVk-template--24555189174657__discover_benefits">
                            <summary>
                                <span class="title">
                                    Was ist die Durchschnittsgröße?
                                </span>
                            </summary>
                            <div class="collapsible__content accordion__content rte" id="Accordion-collapsible_tab_KG6MVk-template--24555189174657__discover_benefits">
                                <p>Your ring size depends on multiple factors, such as the shape of your finger, your weight and how you would like your ring to feel on your finger. The average ring size for most women is between size L1/2 and size N. For men, it is usually between size S and size T1/2.</p>
                            </div>
                        </details>
                    </collapsible-row>
                    <collapsible-row class="accordion">
                        <details id="Details-collapsible_tab_KG6MVk-template--24555189174657__discover_benefits">
                            <summary>
                                <span class="title">
                                    Bestellen Sie ein kostenloses Ringmaß
                                </span>
                            </summary>
                            <div class="collapsible__content accordion__content rte" id="Accordion-collapsible_tab_KG6MVk-template--24555189174657__discover_benefits">
                                <p><a href="/account/login">Anmelden oder registrieren</a>, um ein kostenloses Ringmaß anzufordern.</p>
                            </div>
                        </details>
                    </collapsible-row>
                    <collapsible-row class="accordion">
                        <details id="Details-collapsible_tab_KG6MVk-template--24555189174657__discover_benefits">
                            <summary>
                                <span class="title">
                                    Sind Sie besorgt, die falsche Ringgröße zu bekommen?
                                </span>
                            </summary>
                            <div class="collapsible__content accordion__content rte" id="Accordion-collapsible_tab_KG6MVk-template--24555189174657__discover_benefits">
                                <p>Wir bieten eine einmalige, kostenlose Größenänderung für alle unsere Ringe innerhalb von 60 Tagen nach Lieferung an.</p>
                            </div>
                        </details>
                    </collapsible-row>
                </div>
            </div>
        </div>`) 
    
        var closeFuncRef;
        
        const $modalOptionsList = $modalContents.find(`.size-table-content.option-list`)
        item?.list?.forEach((sizeItem) => {
            const $item = $(`<div class="item choice size-table-row ${PCO_VALUES[name]?.id == sizeItem?.id ? "active" : ""}" data-id="${sizeItem?.id}">
                <div class="title">
                    <div class="item-content">
                        <label class="item-label">
                            <span class="label">
                                <span class="size-name">${sizeItem?.label?.replaceAll("Durschnitt", "Durchschnitt")}</span>
                            </span>
                        </label>
                    </div>
                </div>
                <div class="diameter">${sizeItem?.diameter ?? ""}</div>
                <div class="circumference">${sizeItem?.outer_diameter ?? ""}</div>
            </div>`);
            $modalOptionsList.append($item);
    
            // $item.on("click", () => {
            //     activeItem()
            // })
    
            // document.addEventListener('PCO_VALUES_CHANGED.'+name, function(e) {
            //     const { property, value } = e.detail;
            //     if(value?.id == sizeItem?.id){
            //         activeItem(true)
            //     }else {
            //         $item.removeClass("active")
            //     }
            // })
    
        })
    
        $modalOptionsList.on("click", ".item.choice", function () {
            const $item = $(this); 
            const sizeItem = item.list.find(size => size.id === $item.attr("data-id"));
            PCO_VALUES[name] = {...sizeItem, type: "size"};
            $modalOptionsList.find(".item").removeClass("active");
            $item.addClass("active"); 
            if (typeof closeFuncRef === "function") {
                closeFuncRef();
            }
            $(`.warning-message-inp[data-name="${name}"]`).html("")
        });
        const { closeFunc } = modalItem("Optionen auswählen", $modalContents, false, "size-modal")
        closeFuncRef = closeFunc;
    }
    

    $sizeGuide.on('click', () => {
        open()
    })

    var isOpen = false

    const $dropdownWrapper = $(`<div class="dropdown-group"></div>`)
    $optionSet.append($dropdownWrapper)
    const $dropdownSelected = $(`<div class="dropdown-input sprite-bf">Optionen auswählen</div>`)

    // <li class="item choice  ">
    //     <span class="item-content">
    //         <label class="item-label">
    //             <span class="label">
    //                 <span class="size-name">46</span>
    //                 <span class="size-diameter"> 14.6</span>
    //             </span>
    //         </label>
    //     </span>
    // </li>

    const $options = $(`<div class="dropdown-container">
        <div class="tabpanel nav-tabpanel-0">
            <div class="option-header">
                <div class="size-name">${item?.label?.replaceAll("Durschnitt", "Durchschnitt")}</div>
                <div class="size-diameter">Inner diameter, mm</div>
            </div>
            <ul class="option-list" data-name="${name}">
            </ul>
        </div>   
    </div>`)

    const hideDropdwon = () => {
        $options.hide()
        $dropdownWrapper.removeClass("active")
        isOpen = false;
        bodyClickHideFunc = false
    }

    const $optionsUL = $options.find("ul")
    var $prevActive = null
    item?.list?.forEach((sizeItem) => {
        setNameValSort(name, sizeItem, 'size')
        const $item = $(`<li class="item choice">
            <span class="item-content">
                <label class="item-label">
                    <span class="label">
                        <span class="size-name">${sizeItem?.label?.replaceAll("Durschnitt", "Durchschnitt")}</span>
                        <span class="size-diameter">${sizeItem?.diameter}</span>
                    </span>
                </label>
            </span>
        </li>`);
        $optionsUL.append($item);

        const activeItem = (def) => {
            if($prevActive){
                $prevActive.removeClass("active");
            }
            if(!def){
                PCO_VALUES[name] = {...sizeItem, type: "size"};
            }
            $(`.warning-message-inp[data-name="${name}"]`).html("")
            $item.addClass("active");
            $prevActive = $item;
            $dropdownSelected.text(sizeItem?.label)
            hideDropdwon()
        }

        $item.on("click", () => {
            activeItem()
        })

        document.addEventListener('PCO_VALUES_CHANGED.'+name, function(e) {
            const { property, value } = e.detail;
            // update(value)
            if(value?.id == sizeItem?.id){
                activeItem(true)
                // $dropdownSelected.text(sizeItem?.label)
            }else {
                $item.removeClass("active")
            }
        })

    })

    $dropdownSelected.on("click", function() {
        if(isOpen){
            hideDropdwon();
        }else {
            if(typeof bodyClickHideFunc == "function"){
                bodyClickHideFunc(false, true)
            }
            $options.show()
            $dropdownWrapper.addClass("active")
            bodyClickHideFunc = (e, force) => {
                if ((force || !$(e.target).closest($wrapper).length) && isOpen) {
                    hideDropdwon()
                }
            }   
            isOpen = true;
        }
    })
    sizeOpener[name] = open;

    if(item?.is_required){
        $optionSet.append(`<div data-name="${name}" class="warning-message-inp"></div>`)
    }
    
    $options.hide()
    $dropdownWrapper.append($options)
    $dropdownWrapper.append($dropdownSelected)
    
    return $wrapper;
}

var logo_inside_inputs = []
var logoInside = () => {
    const id = `detail-edit-option-glamira_logo_inside-${randomStr()}`
    const $logoInside = $(`<tr class="row-item item-glamira_logo_inside">
        <td class="detail-label">
            <span class="enable-popover">
                <span style="margin-right: 5px;">
                    Meinekette logo inside
                </span>
                <span class="help_icon target-icon">[?]</span>
            </span>
        </td>
        <td class="detail-value">
            <div class="switcher switcher-checkbox">
                <input type="checkbox" id="${id}" class="switch-checkbox" value="1" checked="${PCO_VALUES?.logo_inside}" />
                <label class="switch-label" for="${id}" data-text-on="Yes" data-text-off="No"><span class="switch"></span></label>
            </div>
        </td>
    </tr>`)
    const $input = $logoInside.find(`input`)
    logo_inside_inputs.push($input)
    $input.on("change", function(e){
        PCO_VALUES.logo_inside = e.target.checked
        logo_inside_inputs.forEach($inp => {
            $inp.prop("checked", PCO_VALUES.logo_inside)
        })
    })
    const $logoPopver = $logoInside.find(`.help_icon`)
    popoverItem($logoPopver, {title: "MEINEKETEE LOGO INSIDE", content: "This is a reference image. The logo on the product will be much smaller than it appears in the photo.", image: "https://cdn-media.glamira.com/media/product_detail/logoon_off_popup.jpg", enable: true})
    return $logoInside;
}
var getMetalAlloyVal = () => {
    let colorTexts = []
    let metalTexts = []
    Object.keys(PCO_VALUES)?.forEach((key) => {
        const item = PCO_VALUES[key]
        if(item?.type == "color" || item?.type == "metal"){
            const idx = PCO_VARIANT_OPTIONS?.[key]?.findIndex((obj) => obj.id == item?.id)
            if(idx > -1){
                const text = PCO_VARIANT_OPTIONS?.[key][idx]?.label
                if(item?.type == "metal"){
                    metalTexts.push(text)
                }else {
                    colorTexts.push(text)
                }
            }
        }
    })
    return colorTexts?.join(" ") + " " + metalTexts.join(" ")
}
var metalAlloyDetails = () => {
    const $metalAlloy = $(`<tr class="row-item item-alloy">
        <td class="detail-label">
            <span data-toggle="popover" data-content-selector=".alloy_colour_data" class="enable-popover" data-original-title="" title="">
                <span style="margin-right: 5px;">
                    Color / Metal
                </span>
                <span class="help_icon target-icon"> [?]</span>
            </span>
        </td>
        <td class="detail-value">
            <span class="value value-alloy"></span>
        </td>
    </tr>`)

    const $value = $metalAlloy.find(`.value`)
    const $popoverItem = $metalAlloy.find('.help_icon')
    popoverItem($popoverItem, {title: "Color / Metal", enabled: true, image: "https://cdn-media.glamira.com/media/product_detail/new_design_2023/alloy.svg", content: "The metal refers to the base material used in the manufacture of the piece of jewelry. The color is determined by the combination of the metal with other alloying elements."})


    const generate = () => {
        const val =getMetalAlloyVal()
        $value.text(val)
    }
    generate()
    document.addEventListener('PCO_VALUES_CHANGED.color_metal', function(e) {
        generate()
    })

    return $metalAlloy

}

var overviewDetails = () => {
    const url_type = customizer_product?.type;
    // if(url_type == "ring" || url_type == "necklace"){
    
    //     const $items = {}
    
    //     const genrate = () => {
    //         Object.keys(PCO_VALUES)?.forEach((key) => {
    //             const pco_obj = PCO_VALUES?.[key]
    //             const idx = PCO_VARIANT_OPTIONS?.[key]?.findIndex((obj) => obj.id === PCO_VALUES[key]?.id)
    //             const item = PCO_VARIANT_OPTIONS?.[key]?.[idx]
    //             if(item && pco_obj?.type !== "color" && pco_obj?.type !== "metal" && item?.id && item?.value){
    //                 let $value = $items?.[key]
    //                 if(!$value){
    //                     const $item = $(`<tr class="row-item item-stone1_type">
    //                         <td class="detail-label">
    //                             <span>
    //                                 ${key}
    //                             </span>
    //                         </td>
    //                         <td class="detail-value">
    //                             <span class="value value-stone1_type"></span>
    //                         </td>
    //                     </tr>`)
    //                     $table.append($item)
    //                     $value = $item.find(`.value`)
    //                     $items[key] = $value;
    //                 }
    //                 $value.text(item?.value ?? "")
    //             }
    //         })
    //     }
    //     genrate()
    
    //     document.addEventListener("PCO_VALUES_CHANGED", function(e) {
    //         genrate()
    //     })
    // }

    const $overviewDetails = $(`<div class="options-detail">
        <div class="detail_item">
            <table class="data-table table-detail">
                <tbody>
                </tbody>
            </table>
        </div>
    </div>`)
    const $table = $overviewDetails.find(`table`)
    
    // const $metalAlloy = metalAlloyDetails()
    const $color = $(`<tr class="row-item color-val-v-parent item-stone1_type">
        <td class="detail-label">
            <span>
                Farbe
            </span>
        </td>
        <td class="detail-value">
            <span class="value color-val-v"></span>
        </td>
    </tr>`)
    const $metal = $(`<tr class="row-item material-val-v-parent item-stone1_type">
        <td class="detail-label">
            <span>
                Material
            </span>
        </td>
        <td class="detail-value">
            <span class="value material-val-v"></span>
        </td>
    </tr>`)
    const $stone = $(`<tr style="display:none" class="row-item ov-stone-val-parent item-stone1_type">
        <td class="detail-label">
            <span class="label"></span>
        </td>
        <td class="detail-value">
            <span class="value ov-stone-val"></span>
        </td>
    </tr>`)
    const $weight = $(`<tr style="display:none" class="row-item ov-weight-val-parent">
        <td class="detail-label">
            <span>
                Gewicht
            </span>
        </td>
        <td class="detail-value">
            <span class="value ov-weight-val"></span>
        </td>
    </tr>`)
    $table.append($stone, $color, $metal, $weight); 
    $("#product-options-details").html($overviewDetails)
    getOptionValues()


    let $allItems = {}
    const $trItem = (title, name, val = "", popover, isClick, v_class) => {
        const $item = $(`<tr class="row-item item-sku">
            <td class="detail-label${popover ? " enable-popover" : ""}">
                <span>${title}</span>
                ${popover ? `<span class="help_icon target-icon">[?]</span>` : ""}
            </td>
            <td class="detail-value">
                <span class="value value-item ${v_class}">${val}</span>
                ${ isClick ? `<span class="value value-product_dimension click-item"> ${isClick} </span>` : `` }
            </td>
        </tr>`)

        if(name){
            $allItems[name] = $item.find(".value-item")
        }
        if(popover){
            popoverItem($item.find(".help_icon"), popover)
        }
        return $item
    }

    // all overview
    const $allOverViewInfo = $(`#product-detail-container .detail-content-wrap`)
    if($allOverViewInfo.length > 0){

        var gen_names = {};
        var $tableItem2;
        
        const stone_obj = [
            {obj: 'value', label: "Steinbesatz"},
            {obj: 'stone_certification', label: "Certification"},
            {obj: 'stone_color', label: "Farbe"},
            {obj: 'stone_clarity', label: "Purity"},
            {obj: 'stone_cutshape', label: "Cut Shape"},
            {obj: 'stone_cut', label: "Cut"},
            {obj: 'stone_carat', label: "Carat"},
            {obj: 'stone_quantity', label: "Number of stones"},
            {obj: 'stone_diameter', label: "Stone Diameter"},
        ]
        const generate_vals = () => {
            let isOkay = false;
            const generateEL = (name) => {
                const $tbody = gen_names[name]
                $tbody.html("")
                
                const idx = PCO_VARIANT_OPTIONS?.[name]?.findIndex((obj) => obj?.id == PCO_VALUES?.[name]?.id)
                var item = PCO_VARIANT_OPTIONS?.[name]?.[idx]
                // const $value = $trItem(name, false, item?.value ?? item?.label)
                
                // const
                stone_obj.forEach((obj) => {
                    const obj_i = item?.[obj?.obj]
                    if(obj_i){
                        const $item = $trItem(obj?.label, false, obj_i)
                        $tbody.append($item)
                    }
                })
                
                if(item?.is_side_stone && $tableItem2){
                    // $tbody2.html("");
                    $tableItem2.find(".detail-title span").text(item?.side_stone_label ?? "Side Stone")
                    const $tb = $(`<tbody>`)
                    let isO = false
                    stone_obj.forEach((obj) => {
                        const obj_i = item?.["side_"+obj?.obj]
                        if(obj_i){
                            const $item = $trItem(obj?.label, false, obj_i)
                            $tb.closest("tbody").append($item)
                            isOkay = true
                            isO = true
                        }
                    })
                    if(isO){
                        $tableItem2.find("table").html($tb)
                    }
                }
                
                // const $certification = $trItem("Certification", false, "GL Certified")
                // const $color = $trItem("Color", false, "White")
                // const $purity = $trItem("Purity", false, "AA")
                // const $shape = $trItem("Curt Shape", false, "Round")
                // const $cut = $trItem("Cut", false, "Very good")
                // const $carat = $trItem("Carat", false, "0.5")
                // const $stoneQuantity = $trItem("Quantity of stones", false, "1")
                // const $diameter = $trItem("Stone Diameter", false, "5.0mm")

                // $tbody.append($value, $certification, $color, $purity, $shape, $cut, $carat, $stoneQuantity, $diameter)

            }
            Object.keys(gen_names).forEach(n => {
                generateEL(n)
            })
            if($tableItem2){
                if(isOkay){
                    $tableItem2.show()
                }else {
                    $tableItem2.hide()
                }
            }
        }

        // const $tableItem = $(`<div class="detail_item general_detail large-4 medium-6 small-12 columns">
        //     <div class="detail-title">
        //         <span class="title">
        //             Generally
        //         </span>
        //     </div>
        //     <table class="data-table table-detail">
        //         <tbody>
        //         </tbody>
        //     </table>
        // </div>`)
        const $tbody = $(".overview-general-table")

        // const $productNumber = $trItem("Product Number", false, "", false, false, "value-sku-variant")
        // const $gender = $trItem("Gender", false, "Woman")
        // const $solid = $trItem(`Solid`, false, "yes", {title: "Solid:", enabled: true, image: "https://cdn-media.glamira.com/media/product_detail/new_design_2023/solid.svg", content: "Solid indicates that the product is made entirely from the specified alloy."})

        // const $tbody = $tableItem.find("tbody")
        // $tbody.append($productNumber, $gender, $solid)
        if(typeof product_q_ans_metafields === "object"){
            var kept_obj = {}
            Object.keys(product_q_ans_metafields).map((item) => {
                if(item == "material_weights"){
                    // const val_idx
                    let val = ""
                    const $item = $trItem("Gewicht", false, val)
                    $tbody.append($item)
                    $item.addClass("material_weights").attr("data-vals", product_q_ans_metafields[item])
                }else {
                    const classN = "cc-item-"+item 
                    let $item = $("."+classN)
                    if($item.length == 0){
                        $item = $trItem(item, false, product_q_ans_metafields[item])
                        $item.addClass(classN)
                    }
                    $tbody.append($item)
                }
            })
        }
        getOptionValues()

        // const $colorMetal = metalAlloyDetails()
        // const $logoInside2 = logoInside()
        // $tbody.append($colorMetal, $logoInside2)

        // $allOverViewInfo.html("")
        // $allOverViewInfo.append($tableItem)

        Object.keys(PCO_VALUES).forEach((obj) => {
            if(PCO_VALUES[obj]?.type == "size"){
                const $ringSize = $trItem("Ring Size", false, "", false, "Klicken Sie zum Bearbeiten")
                $ringSize.find('.click-item').on("click", () => {
                    if(typeof sizeOpener[obj] === "function"){
                        sizeOpener[obj]();
                    }
                })
                const $value = $ringSize.find('.value-item')
                const setVal = () => {
                    const val_id = PCO_VALUES[obj]?.id
                    var label = ""
                    if(val_id){
                        const slIdx = PCO_VARIANT_OPTIONS[obj].findIndex((obj) => obj.id == val_id)
                        if(slIdx > -1){
                            const item = PCO_VARIANT_OPTIONS[obj][slIdx]
                            if(item?.label){
                                label = item?.label
                            }
                        }
                    }
                    $value.text(label)
                    if(!label){
                        $value.hide()
                    }else {
                        $value.show()
                    }
                }
                setVal()
                document.addEventListener("PCO_VALUES_CHANGED."+obj, () => {
                    setVal()
                })
                $tbody.append($ringSize)
            }else if((!PCO_VALUES[obj]?.type || PCO_VALUES[obj]?.type == "stone")){
                // <span class="enable-popover"><span class="help_icon target-icon">[?]</span></span>
                if(PCO_VARIANT_OPTIONS[obj]){
                    const $tableItem = $(`<div class="detail_item general_detail large-4 medium-6 small-12 columns">
                        <div class="detail-title">
                            <span class="title">
                                <span>${obj?.toLowerCase() == "stone" ? "Hauptstein" : obj}</span>
                            </span>
                        </div>
                        <table class="data-table table-detail">
                            <tbody>
                            </tbody>
                        </table>
                    </div>`)
                    const $tbody = $tableItem.find("tbody")
                    gen_names[obj] = $tbody
                    $allOverViewInfo.append($tableItem)


                    $tableItem2 = $(`<div class="detail_item general_detail large-4 medium-6 small-12 columns">
                        <div class="detail-title">
                            <span class="title">
                                <span>${obj}</span>
                            </span>
                        </div>
                        <table class="data-table table-detail">
                            <tbody>
                            </tbody>
                        </table>
                    </div>`)
                    // const $tbody2 = $tableItem2.find("table")
                    // gen_names["side_stone_type_2"] = $tbody2
                    $allOverViewInfo.append($tableItem2)


                    // var prevPopover;
                    // const clickItem = $tableItem.find(".detail-title .help_icon").first()
                    // const popoverGen = debounce(() => {
                    //     if(prevPopover){
                    //         prevPopover.remove()
                    //     }
                    //     clickItem.off("click")
                    //     prevPopover = popoverItem(clickItem, {title: obj, enabled: true, image: PCO_ACTIVE_IMAGES?.[0]})
                    // }, 200)
                    // popoverGen()

                    // document.addEventListener("PCO_VALUES_CHANGED", () => {
                    //     popoverGen()
                    // })
                }
            }
        })
        generate_vals()
        document.addEventListener("PCO_VALUES_CHANGED", () => {
            generate_vals()
        })
    }
}


var customVariantProductItems = (list, is_large) => {
    const $container = $(`<div class=""></div>`)
    const $list = $(`<ul class="scrollable-content-main scrollable-content-cm products collection row no-padding"></ul>`)
    list?.forEach((item) => {
        const values = item?.values
        const itemC = checkValsPCO(values)
        const $item = $(`<li class="${is_large ? "small-4 medium-2 large-1-5" : `small-6 medium-4`} columns product-item">
            <div class="product-item-photo">
                <img src="${itemC?.imgs?.[0]}" width="400" height="400"/>
            </div>
            <div class="product-item-details">
                <div class="short-description">
                    ${item?.title}
                </div>
                <div class="price-box product-price">
                    <span class="price">
                        <span class="price">${itemC?.format_price}</span>
                    </span>
                </div>
            </div>
        </li>`)
        $item.on("click", () => {
            Object.keys(values).forEach((obj) => {
                if(PCO_VALUES[obj]){
                    const id = values[obj]
                    const idx = PCO_VARIANT_OPTIONS?.[obj]?.findIndex((checkObj) => checkObj.id == id);
                    const checkItem = PCO_VARIANT_OPTIONS?.[obj]?.[idx]
                    PCO_VALUES[obj] = {...checkItem, type: PCO_NAME_TYPES[obj] ?? false}
                }
            })

            document.getElementById('customisation-options').scrollIntoView({ behavior: 'smooth' });
        })
        $list.append($item)
    })
    $container.append($list)
    return $container;
}

var expressDeliverVariants = () => {
    const express_delivery = PCO_DATA?.customizer?.metadata?.express_delivery
    const $variants = $(".product-delivery-wrapper .variants")
    $variants.addClass("scrollable-content-cm product-items-wrapper-cm")
    if(express_delivery?.enabled && $variants?.length > 0){
        $(".delivery-product-variant.express").show()
        $container = customVariantProductItems(express_delivery?.list)
        $variants.html($container)
        scrollableContentCM($variants[0])
    }else {
        $(".delivery-product-variant.express").remove()
    }
}
var recommendedVariantsGenerate = () => {
    const recommended_variants = PCO_DATA?.customizer?.metadata?.recommended_variants
    const $main = $("#custom-variant-options")
    const $variants = $main.find(".products-list-container")
    if(recommended_variants?.enabled && recommended_variants?.list?.length > 0 && $variants?.length > 0){

        $main.show()
        $main.find(".section-header--title").text(recommended_variants?.title ?? "Recommended Variants")

        $variants.addClass("scrollable-content-cm product-items-wrapper-cm")
        $container = customVariantProductItems(recommended_variants?.list, true)
        $variants.html($container)
        scrollableContentCM($variants[0])
    }else {
        $main.remove()
    }
}

var popoverItem = ($opener, popover) => {

    if(!$opener || !popover){
        return;
    }

    $opener.on("click", () => {

        const popupOffset = $opener.offset();
        const popupWidth = $opener.outerWidth();
        const popupHeight = $opener.outerHeight();
        
        const $popoverItem = $(`<div class="popover engraving_data fade bs-popover-right show" role="tooltip" x-placement="right">
            <div class="arrow"></div>
            <div class="popover-header">
                <div class="popover-title"> ${popover?.title ?? ""} </div>
                <a class="popover-close" href="javascript:void(0)">
                    <span class="sprite-at icon">X</span>
                </a>
            </div>
            <div class="popover-body">
                <div class="content">
                    ${popover?.image ? 
                        `<div class="image_thumblain">
                            <img src="${popover?.image}">
                        </div>` : ""
                    }
                    ${popover?.content ?? ""}
                </div>
            </div>
        </div>`)

        $("body").append($popoverItem)

        const positionPopover = () => {
            const popverItemWidth = $popoverItem.outerWidth()
            let x = popupOffset.left + popupWidth + 10;
            if(popverItemWidth + x >= $(window).innerWidth()){
                const toMinus = popverItemWidth + x - $(window).innerWidth()
                x -= toMinus+10
            }
            const y = popupOffset.top + popupHeight / 2 - $popoverItem.outerHeight() / 2;
            const z = 0; 
            $popoverItem.css({
                transform: `translate3d(${x}px, ${y}px, ${z}px)`,
                "will-change": "transform",
            });
            $popoverItem.children(".arrow").css("top", popupOffset.top - $popoverItem.offset().top - 12);
        };
        positionPopover()


        const hidePopOver = () => {
            $popoverItem.remove()
            bodyClickHideFunc = false;
            open = false;
        }
        var open = false;
        $popoverItem.find(".popover-close").on("click", () => {
            hidePopOver()
        })

        if(typeof bodyClickHideFunc == "function"){
            bodyClickHideFunc(false, true)
        }

        bodyClickHideFunc = (e, force) => {
            if(open){
                if((force || $(e.target).closest(".popover").length == 0) && !$(e.target).hasClass("popver")){
                    hidePopOver();
                }
            }
        }   
        setTimeout(() => {
            open = true;
        }, 200);
    })
}

// const modalItem = (title, content, onClose, className) => {
//     $modal = $(`<div class="modal-slide modal-sm modal--slide-up-m _inner-scroll ${className}">
//         <div data-role="focusable-start" tabindex="0"></div>
//         <div class="modal-inner-wrap">
//             <div class="modal-header">
//                 <div class="modal-title">${title}</div>
//                 <button class="action-close" type="button">
//                     <span>Close</span>
//                 </button>
//             </div>

//             <div class="modal-content">

//             </div>

//         </div>    
//     </div>`)
//     const $overlay = $(`<div class="modal-click-capture--product"></div>`)

//     const close = () => {
//         $overlay.remove()
//         $modal.removeClass("_show")
//         setTimeout(() => {
//             $modal.remove()
//         }, 300);
//         if(typeof onClose == "function"){
//             onClose()
//         }
//     }
//     $overlay.on("click", () => {
//         close()
//     })
//     $modal.find(".action-close").on("click", () => {
//         close()
//     })

//     $modal.find(".modal-content").html(content)

//     $("body").append($modal, $overlay).ready(() => {
//         $modal.addClass("_show")
//     })

//     return { closeFunc: close}
// }

var render_item = (item, name, active) => {
    let nameC = name;
    if(item?.type == "metal" || item?.type == "color"){
        nameC = item?.name
    }
    switch (item?.type) {
        case "choice":
        case "metal": 
            return choice_list_items(item, nameC ?? name, active, item?.type == "metal");

        case "image-choice":
            return image_choice_list(item, item?.name || name, active);

        case "color":
            return color_choice_list(item, item?.name || name, active);

        case "engraving":
            return engraving_item(item);

        case "box":
            return box_item(item, item?.name || name);

        case "size":
            return size_item(item, item?.name || name);

        default:
            return ""; 
    }
};


function shopifyFormatCurrency(cents) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/;

    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
        if (isNaN(number) || number == null) {
            return "0";
        }

        const numString = (number / 100.0).toFixed(precision);
        const parts = numString.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
    }

    const formatString = customizer_product?.money_format
    if (!formatString) {
        return cents / 100
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
        switch (placeholder) {
            case "amount":
                return formatWithDelimiters(cents, 2);
            case "amount_no_decimals":
                return formatWithDelimiters(cents, 0);
            case "amount_with_comma_separator":
                return formatWithDelimiters(cents, 2, ".", ",");
            case "amount_no_decimals_with_comma_separator":
                return formatWithDelimiters(cents, 0, ".", ",");
            case "amount_with_apostrophe_separator":
                return formatWithDelimiters(cents, 2, "'", ".");
            case "amount_no_decimals_with_space_separator":
                return formatWithDelimiters(cents, 0, " ");
            case "amount_with_space_separator":
                return formatWithDelimiters(cents, 2, " ", ",");
            case "amount_with_period_and_space_separator":
                return formatWithDelimiters(cents, 2, " ", ".");
            default:
                return match;
        }
    });
}

var PCO_CONDITION_STATUS = {}
var updateConditionProperites = debounce(() => {
    if(PCO_DATA?.conditions){

        const new_condition_status = {}
        const variant_values = {...PCO_VALUES?.variant_val}

        Object.keys(PCO_DATA?.conditions).forEach((name) => {

            if(!Object.hasOwnProperty(new_condition_status)){
                new_condition_status[name] = true;
            }

            if(new_condition_status?.[name] === true){
                let show = true;
                PCO_DATA?.conditions?.[name]?.forEach(item => {
                    if(item?.when && item?.value && item?.element){
                        
                        if(item?.shopify_variant || PCO_VARIANT_CONNECTIONS?.[item?.when]){
                            checkVAl = variant_values?.[item?.when] ?? ""
                        }else {
                            checkVAl = PCO_VALUES?.[item?.when]?.id ?? ""
                        }
                        if(checkVAl){
                            if(item?.value == checkVAl){
                                if(item?.show == "0"){
                                    show = false;
                                    return;
                                }
                            }else if(item?.show == "1"){
                                show = false;
                                return;
                            }
                        }
                    }
                })
                new_condition_status[name] = show;
            }

        })

        Object.keys(new_condition_status).forEach((name) => {
            if(new_condition_status[name] != PCO_CONDITION_STATUS[name]){
                const $item = $(`#customisation-options [data-name="${name}"]`).closest(".condition-item")
                if(new_condition_status[name]){
                    $item.slideDown();
                }else {
                    $item.slideUp();
                }
                PCO_CONDITION_STATUS[name] = new_condition_status[name]
            }
        })
    }
}, 100)

var checkValsPCO = (values, variant) => {
    let id_sum = []
    var labels = []

    if(!variant){
        variant = $('variant-selects')?.[0]?.currentVariant
    }
    if(!variant && customizer_product?.product?.variants?.length == 1){
        variant = customizer_product?.product?.variants[0]
    }
    let price_sum = 0

    const vItems = {}

    if(values){
        const check_vals_obj = values
        values = {}
        Object.keys(check_vals_obj).forEach((obj) => {
            const id = check_vals_obj[obj]
            const idx = PCO_VARIANT_OPTIONS?.[obj]?.findIndex((checkObj) => checkObj.id == id)
            const item = PCO_VARIANT_OPTIONS?.[obj]?.[idx]
            values[obj] = item;
        })
    }
    const check_values = values ? values : PCO_VALUES;


    const url = new URL(window.location.href);
    let variantLabel = [variant?.title];

    var has_stone;

    for (const idx in sort) {
        const name = sort[idx]
        const item = check_values?.[name]
        if(item?.has_image){
            id_sum.push(item?.id)
        }
        if(values){
            labels.push(item?.value ?? item?.label)
        }
        const vItemIdx = PCO_VARIANT_OPTIONS?.[name]?.findIndex((obj) => obj.id == item?.id)
        const vItem = PCO_VARIANT_OPTIONS?.[name]?.[vItemIdx]
        if(vItem?.is_stone){
            has_stone = true;
            $(".ov-stone-val-parent").show()
            $(".ov-stone-val-parent").find(".label").text(name)
            $(".ov-stone-val").text(vItem?.value ?? vItem?.label)
        }
        vItems[name] = vItem;
        if (vItem?.value || vItem?.label) {
            url.searchParams.set("cv__" + name, vItem?.value ?? vItem?.label);
        } else {
            url.searchParams.delete("cv__" + name);
        }
        if(item?.is_variant && !PCO_VARIANT_CONNECTIONS?.[name] && item?.type != "size"){
            variantLabel.push(item?.value ?? item?.label)
        }
        if(!PCO_VARIANT_CONNECTIONS[name]){
            const n_price = parseFloat(item?.price ?? 0);
            price_sum += n_price
            PCO_PRICING_REF[name] = n_price;
        }
        if (item?.engraving_preview && !values) {
            $(".engraving-preview.engraving-inside").css("background-image", `url(${item?.engraving_preview})`)
        }
    }
    window.history.replaceState({}, '', url.toString());
    if(!has_stone){
        $(".ov-stone-val-parent").hide()
    }
    
    // price_sum = 

    const clasNameCheck = "data-value-name-"
    $("#customisation-options .value_selected").each(function(){
        const $this = $(this)
        const classNames = $this[0].className.split(/\s+/);
        let values = []
        let isEngraving
        for(let i = 0; i < classNames.length; i++){
            if(classNames[i]?.includes(clasNameCheck)){
                if(classNames[i]?.includes("engraving__v__")){
                    isEngraving = true
                    break;
                }
                const vItem = vItems[classNames[i]?.replace(clasNameCheck, "")?.replaceAll("s__c", " ")]
                values.push(vItem?.value ?? vItem?.label)
            }
        }
        if(!isEngraving){
            if(values?.length > 0 && (values[0] || values[1])){
                $this.text("("+values.join(" ")+")")
            }else {
                $this.text("")
            }
        }
    })

    Object.keys(PCO_VALUES).forEach((key) => {
        const item = PCO_VALUES?.[key]
        if(item?.type == "color" && item?.engraving_preview){
            $(".engraving-preview.engraving-inside").css("background-image", `url(${item?.engraving_preview})`)
        }
    })

    const comparePrice = shopifyFormatCurrency((price_sum * 100) + (variant?.compare_at_price ?? 0))
    const mainPrice = shopifyFormatCurrency((price_sum * 100) + (variant?.price ?? 0))
    if(!values && PCO_DATA){
        $(".product-price-container .amount:not(.compare-at-price)").text(mainPrice)
        $(".product-price-container .amount.compare-at-price").text(comparePrice)
    }

    $(".product-full-variant-label").text(variantLabel?.join("/"))
    const imgs = PCO_IMAGES?.[id_sum.join("-")]
    if(!values){
        const img_id_name = "#pco-img-"
        const img_class_name = ".pco-img-"
        if (imgs) {
            PCO_ACTIVE_IMAGES = imgs;
            $(".pco-img-bottom").hide()
            imgs?.forEach((src, idx) => {
                $("img"+img_id_name + (idx + 1)).attr("src", src).attr('srcset', src)
                $("img"+img_class_name + (idx + 1)).attr("src", src).attr('srcset', src)
                $(img_class_name + (idx + 1)+".pco-img-bottom").show()
            })
        }
    }
    if(!imgs){
        const variants = customizer_product?.product?.variants;
        const activeOption = variant;
        
        let colorOptionIndex = false;
        customizer_product?.product?.options?.forEach((item, idx) => {
            const nameL = item?.toLowerCase()
            if(nameL?.includes("color") || nameL?.includes("colour") || nameL?.includes("couleur") || nameL?.includes("farbe")){
                colorOptionIndex = idx+1;
                // return;
            }
        })
        const activeColorVal = activeOption?.["option"+colorOptionIndex]
        $(".pco-img-bottom").removeClass("is-active is-selected").hide()
        let img;
        let featured_media_id = null
        let featured_medias = {}
        var lenCheck = 0;
        variants?.forEach((item, idx) => {
            featured_medias[item?.featured_media?.id] = true
            if(item?.["option"+colorOptionIndex] == activeColorVal){
                lenCheck++
                const $item = $(`.pco-img-bottom[data-id="${item?.featured_media?.id}"]`)
                $item.show().addClass("is-active")
                featured_media_id = item?.featured_media?.id
                if(!img){
                    $item.addClass("is-selected")
                    img = $item.find('img').attr("src")
                }
            }
        })
        let start = false
        for(let i = 0; i < customizer_product?.product?.media?.length; i++){
            const item = customizer_product?.product?.media[i]
            if(item?.id == featured_media_id && !start){
                start = true
            }
            if(start){
                if(!featured_medias[item?.id]){
                    const $item = $(`.pco-img-bottom[data-id="${item?.id}"]`)
                    $item.show().addClass("is-active")
                    lenCheck++
                    if(!img){
                        $item.addClass("is-selected")
                        img = $item.find('img').attr("src")
                    }
                }else {
                    if(featured_media_id != item?.id){
                        break;
                    }
                }
            }
        }
        $(`.pco-img-bottom[data-alt-text]`).each(function() {
            const alt_texts = $(this).attr("data-alt-text")?.split(",")
            if(alt_texts?.includes(activeColorVal)){
                $(this).show().addClass("is-active")
                lenCheck++
                if(!img){
                    $(this).addClass("is-selected")
                    img = $(this).find('img').attr("src")
                }
            }
        })
        if(lenCheck < 2 && variants?.length < 2){
            const $item = $(`.pco-img-bottom`)
            $item.show().addClass("is-active")
        }

        if(img){
            $('product-add-to-cart-sticky').find('.pco-img-1').attr("src", img)
        }
        setTimeout(() => {
            // window.updateProductMedia()
            // if(typeof window.updateProductDisabled == "function"){
            //     window.updateProductDisabled()
            // }
            const variantSelect = $('variant-selects')[0]
            if(variantSelect?.setDisabled){
                variantSelect.setDisabled()
            }
            $(".thb-product-detail product-slider")[0]?.reInit()
            $('.product-image-container').addClass("changed")
        }, 0);
    }
    
    if(values){
        return {imgs: imgs, format_price: format_price, labels: labels}
    }
}
var updatePriceImage = debounce((values) => {
    checkValsPCO()
    // let id_sum = []
    // let price_sum = 0
    // const check_values = values ? values : PCO_VALUES;
    // for (const idx in sort) {
    //     const name = sort[idx]
    //     const item = check_values?.[name]
    //     if(item?.has_image){
    //         id_sum.push(item?.id)
    //     }
    //     // id_sum += item?.id
    //     price_sum += parseFloat(item?.price)
    //     if (item?.engraving_preview && !values) {
    //         $(".engraving-preview.engraving-inside").css("background-image", `url(${item?.engraving_preview})`)
    //     }
    // }

    // const format_price = shopifyFormatCurrency(price_sum * 100)
    // //  + " "+Shopify?.currency?.active;
    // if(!values){
    //     $(".product-price-container .amount").text(format_price)
    // }

    // const imgs = PCO_IMAGES?.[id_sum.join("-")]
    // if(!values){
    //     const img_id_name = "#pco-img-"
    //     if (imgs) {
    //         PCO_ACTIVE_IMAGES = imgs;
    //         imgs?.forEach((src, idx) => {
    //             $(img_id_name + (idx + 1)).attr("src", src).attr('srcset', src)
    //         })
    //     }
    // }
}, 100)
window.customizer_price_udpate = checkValsPCO;
var connectedVariantsValues = () => {

    const variant = $('variant-selects')?.[0]?.currentVariant
    const options = customizer_product.product.options
    options?.some((obj, idx) => {
        if($(`.has-variant-connection[data-variant-option="${obj}"]`).length > 0){

            const val = variant?.["option"+(idx+1)]
            let $this = $(`.has-variant-connection[data-variant-option="${obj}"][data-value="${val}"]`);

            const name = $this.data("name");
            const variant_id = $this.data("id");
            const price = $this.data("price");
        
            $(`.pco-variant-option[data-name="${name}"]`).removeClass("active");
            $this.addClass("active");
        
            const item = {
                id: variant_id,
                price: price
            };
        
            const engravingPreview = $this.data("engraving-preview");
            if (engravingPreview) {
                item.engraving_preview = engravingPreview;
            }
    
            if ($this.attr("data-type")) {
                item.type = $this.attr("data-type");
            }
            if ($this.hasClass("has-preview-image")) {
                item.has_image = true;
            }
            PCO_VALUES[name] = item
        }
    })
}
var getOptionValues = () => {
    let variant = $('variant-selects')?.[0]?.currentVariant
    const product = customizer_product.product 
    const options = product?.options

    variant = variant?.id ? variant : customizer_product?.product?.variants?.length == 1 ? customizer_product?.product?.variants[0] : null

    let metalIndex = false
    let colorOptionIndex = false
    options?.forEach((item,idx) => {
        const nameL = item?.toLowerCase()
        if(nameL?.includes("color") || nameL?.includes("colour") || nameL?.includes("couleur") || nameL?.includes("farbe")){
            colorOptionIndex = idx+1;
            return;
        }else if(nameL == "metal" || nameL == "material"){
            metalIndex = idx+1;
            return;
        }
    })
    let metal_val = variant?.['option'+metalIndex]
    if(!metal_val && typeof product_q_ans_metafields == Object){
        metal_val = product_q_ans_metafields?.[`Material`]
    }
    if(metal_val){
        $(".material-val-v").text(metal_val ?? "")
        if(!variant?.['option'+metalIndex]){
            $(".material-val-v-parent").hide()
            $("#product-options-details .material-val-v-parent").show()
        }
    }else {
        $(".material-val-v-parent").hide()
    }

    let color_val = variant?.['option'+colorOptionIndex]
    if(!color_val && typeof product_q_ans_metafields == Object){
        color_val = product_q_ans_metafields?.[`Farbe`]
    }
    if(color_val){
        $(".color-val-v").text(color_val ?? "")
        if(!variant?.['option'+colorOptionIndex]){
            $(".color-val-v-parent").hide()
            $("#product-options-details .color-val-v-parent").show()
        }
    }else {
        $(".color-val-v-parent").hide()
    }
    let sku = variant?.sku
    $(".value-sku-variant").text(sku)
    if(sku){
        $(".value-sku-variant").closest(".row-item").show()
    }else {
        $(".value-sku-variant").closest(".row-item").hide()
    }
    if($(".material_weights").length > 0){
        const vals = $(".material_weights").attr('data-vals')?.split(",")
        const matrial_values = {};
        let idxx = 0;
        customizer_product?.product?.variants?.forEach((item) => {
            if(!matrial_values.hasOwnProperty(item?.['option'+metalIndex])){
                matrial_values[item?.['option'+metalIndex]] = idxx;
                idxx++
            }
        })
        const idx = matrial_values?.[variant?.['option'+metalIndex]];
        $(".material_weights").find('.value').text(vals?.[idx])
        if(vals?.[idx]){
            $(".material_weights").show()
            $(".ov-weight-val").text(vals?.[idx])
            $(".ov-weight-val-parent").show();
        }else {
            $(".material_weights").hide()
            $(".ov-weight-val-parent").hide();
        }
    }
    if(variant?.taxable){
        $(".taxable-message").show()
        $(".no-taxable-message").hide()
    }else {
        $(".taxable-message").hide()
        $(".no-taxable-message").show()
    }

    const variant_values = {}
    customizer_product?.product?.options?.forEach((opt, idx) => {
        variant_values[opt] = variant?.["option"+(idx+1)]
    })
    PCO_VALUES.variant_val = variant_values
    updateConditionProperites()
}
$(document).ready(function() {
    getOptionValues()
})
document.addEventListener("product:variant-change", function(e) {
    const variant = e.detail.variant
    const forced = e.detail.force

    if(forced){
        connectedVariantsValues()
    }
    getOptionValues()
    checkValsPCO(false, variant)
})


var update_engraving = (input) => {
    const max_len = input.attr("data-max")
    let val = input.val()
    const len = val?.length
    val = val.substring(0, max_len)
    const engraving_input = input.closest(".engraving-input")
    engraving_input.find(".pco-char-count").text(val?.length)
    input.val(val)
    if (len > max_len) {
        engraving_input.find(".error-message").text("Engravings are limited to 25 characters").addClass("visible")
    } else {
        engraving_input.find(".error-message").removeClass("visible")
    }

    const name = input.attr('data-name')
    const id = input.attr('data-id')
    let font = input.closest(".engraving-group").find(".font-list .font-item.active").attr('data-font')
    if(!font){
        font = input.attr("data-font");
    }

    $(`.warning-message-inp[data-name="${name}"]`).html("")

    if(name && id){
        if(!PCO_VALUES["engraving_list"]){
            PCO_VALUES["engraving_list"] = {}
        }
        PCO_VALUES["engraving_list"][name] = {id: id, font: font, name: name, text: val}
        let texts = []
        Object.keys(PCO_VALUES.engraving_list)?.forEach((obj) => {
            texts.push(PCO_VALUES.engraving_list[obj]?.text)
        })
        input.closest(".option-item").find(".value_selected").text("("+texts.join(" - ")+")")
    }

    input.closest(".engraving-group").find(".text-path-el").text(val)
}
var quickConfigurationSetup = () => {
    let quick_configuration = PCO_DATA?.customizer?.metadata?.quick_configuration
        
    // generate variants 
    const options_list = PCO_DATA?.customizer?.options?.list
    const variantItemsAll = {}

    const recursive_check = (list) => {
        list?.length > 0 && list?.map(item => {
            if(item?.type == "engraving") {
                return
            }
            if(item?.list?.length > 0 || item?.has_sub_item){
                recursive_check(item?.list)
            }else if(item?.is_variant){
                if(!variantItemsAll[item?.name]){
                    variantItemsAll[item?.name] = []
                }
                variantItemsAll[item?.name].push(item)
            }
        })
    }
    recursive_check(options_list)
    let seenCombinations = new Set();
    PCO_VARIANT_OPTIONS = variantItemsAll;

    const generateVariants = (options) => {
        const optionKeys = Object.keys(options);
        if (optionKeys.length === 0) return [];
        const combineOptions = (keys, currentIndex, currentCombination) => {
            if (currentIndex === keys.length) {
                return [currentCombination];
            }
    
            const currentKey = keys[currentIndex];
            const currentOptions = options[currentKey] || [];
            const combinations = [];
    
            currentOptions.forEach((option) => {
                const newCombination = { ...currentCombination };
                newCombination[currentKey] = option;
                combinations.push(
                    ...combineOptions(keys, currentIndex + 1, newCombination)
                );
            });
    
            return combinations;
        };
    
        const allCombinations = combineOptions(optionKeys, 0, {});
    
        const formattedVariants = allCombinations.map((combination) => {
            let labels = [];
            let ids = [];
            let price = 0;
            let compare_at_price = 0;
    
            let is_all_has_img = true;
            let img_list_labels = [];
            let img_list_ids = [];
            let first_id = false;
    
            Object.keys(combination).forEach((key, idx) => {
                const option = combination[key];
                const label = `${key} - ${option.value ?? option?.label}`;
                labels.push(label);
                ids.push(option?.id);
    
                if (option?.has_image) {
                    img_list_labels.push(label);
                    img_list_ids.push(option?.id);
                }
    
                if (idx === 0) {
                    first_id = option;
                }
    
                if (is_all_has_img && !option?.has_image) {
                    is_all_has_img = false;
                }
    
                const pp = parseFloat(option?.price || 0);
                const cp_pp = parseFloat(option?.compare_at_price || 0);
                price += pp;
                compare_at_price += Math.max(cp_pp, pp);
            });
    
            const variantId = ids.join("-"); 
    
            if (seenCombinations.has(variantId)) {
                return null; 
            }
    
            const v_item = {
                label: labels.join(" / "),
                id: variantId,
                price: price,
                options: ids,
                compare_at_price: compare_at_price,
            };
            seenCombinations.add(variantId);
            return v_item;
        }).filter(Boolean); 
    
        return formattedVariants;
    };


    const dynamicVariants = generateVariants(variantItemsAll);
    PCO_DYNAMIC_VARIANTS = dynamicVariants;
    

    if(true){
    // if(quick_configuration?.enabled && quick_configuration?.list?.length > 0){
        let lowestPrice = dynamicVariants[0]?.price ?? 0;
        let highestPrice = lowestPrice;

        for(let i = 1; i < dynamicVariants?.length; i++){
            lowestPrice = Math.min(lowestPrice, dynamicVariants[i]?.price)
            highestPrice = Math.max(highestPrice, dynamicVariants[i]?.price)
        }

        const product_real_variants = customizer_product?.product?.variants
        let lowestPriceVariant = false;
        let higestPriceVariant = lowestPriceVariant;
        let lowestVariant = product_real_variants?.[0];
        let higestVariant = lowestVariant;
        for(let i = 0; i < product_real_variants?.length; i++){
            const variant = product_real_variants[i]
            if(!variant?.available){
                continue;
            }
            if(lowestPriceVariant > variant?.price || !lowestPriceVariant){
                lowestVariant = variant
                lowestPriceVariant = variant?.price
            }
            if(higestPriceVariant < variant?.price){
                higestVariant = variant
            }
            higestPriceVariant = Math.max(higestPriceVariant, variant?.price)
        }
        lowestPrice += (lowestPriceVariant / 100)
        highestPrice += (higestPriceVariant / 100)
        
        
        const $quickConfWrapper = $(`<div class="MuiCollapse">
            <div class="price-range-combine-configurable-wrap desktop"></div>
        </div>`)
        $(`#price-range-combine-configurable-wrap-desktop`).html($quickConfWrapper)
        const $quickTitle = $(`<div class="price-range-content combine-label-wrap">
            <span class="price-range">
                <span>Konfigurierbarer Preisbereich</span>
                <span class="help_icon target-icon"></span>
            </span>
        </div>`)
        const $quickConfButton = $(`<div class="quick-configuration-wrap desktop collapse-action">
            <div class="quick-configuration">
                <div class="configuration-label">
                    <span>${shopifyFormatCurrency(lowestPrice * 100)} - ${shopifyFormatCurrency(highestPrice * 100)}</span>
                </div>
            </div>
        </div>`)

        $quickTitle.on("click", () => {
            const content = `<div class="infos">
                <div>
                    <div class="info-title">
                        Preisspanne des Produkts
                    </div>
                    <div>
                        <p>Der angezeigte Preis gibt Ihnen eine Orientierung, liegt jedoch innerhalb einer flexiblen Preisspanne. Je nach individuellen Anpassungen kann der Endpreis variieren.</p>
                        <p>Diese Spanne ergibt sich aus den verschiedenen Auswahlmöglichkeiten, die Sie für dieses Produkt haben. Der finale Preis richtet sich nach den gewählten Materialien, insbesondere der Stein- und Metallart. Unser Ziel ist es, Ihnen maximale Flexibilität zu bieten, damit Sie eine Auswahl treffen können, die sowohl Ihrem Stil als auch Ihrem Budget entspricht.</p>
                    </div>
                </div>

                <div>
                    <div class="info-title">Einflussfaktoren auf den Preis:</div>
                </div>

                <div>
                    <div class="info-title">1. Steintypen</div>
                    <div>
                        <p>Sie haben die Möglichkeit, zwischen verschiedenen Steinen zu wählen – von Diamanten über Edelsteine bis hin zu Halbedelsteinen. Die jeweiligen Materialwerte beeinflussen die Preisgestaltung entsprechend.</p>
                    </div>
                </div>

                <div>
                    <div class="info-title">2. Metallarten</div>
                    <div>
                        <p>Ebenso können Sie das Metall individuell bestimmen. Ob Gold, Silber oder Platin – die Wahl des Metalls trägt entscheidend zur Preisstruktur bei.</p>
                        <p>-</p>
                        <p>Der niedrigste Preis innerhalb der Spanne bezieht sich in der Regel auf Kombinationen mit preisgünstigeren Materialien wie Halbedelsteinen und Silber. Der höchste Preis umfasst hingegen hochwertige Varianten, beispielsweise Diamanten in Verbindung mit Platin.</p>
                        <p>Bitte beachten Sie, dass die angegebene Preisspanne eine Orientierungshilfe ist. Der genaue Preis wird im Bestellprozess berechnet und angezeigt, sobald Sie Ihre individuellen Anpassungen vorgenommen haben.</p>
                    </div>
                </div>

                <div>
                    <div class="info-title">Rabatte und Aktionen</div>
                    <div>
                        <p>Gelegentlich bieten wir exklusive Rabattaktionen an. Diese sind nicht unmittelbar in den angegebenen Preisen oder der dargestellten Preisspanne berücksichtigt. Falls eine Rabattaktion aktiv ist, kann der reduzierte Preis beim Bezahlvorgang angewendet werden – entweder durch automatische Berücksichtigung oder durch die Eingabe eines Gutscheincodes.</p>
                        <p>Bitte beachten Sie, dass diese Angebote nur während spezieller Aktionszeiträume gültig sind.</p>
                    </div>
                </div>
            </div>`
            modalItem("Preisspanne", content)
        })

        const $quickOptions = $(`<div class="MuiCollapse-wrapper">
            <div class="MuiCollapse-wrapperInner price-range-combine-configurable-wrap">
                <div class="configuration-content"></div>
            </div>
        </div>`)

        if(!quick_configuration || !quick_configuration?.list || quick_configuration?.list?.length == 0){
            if(!quick_configuration){
                quick_configuration = {list: []}
            }
            const item_1 = {title: "Höchster Preis", variant: higestVariant}
            const item_2 = {title: "Niedrigster Preis", variant: lowestVariant}
            quick_configuration.list = [item_1, item_2]
        }

        const product_options = customizer_product?.product?.options

        const $optionsUL = $(`<ul class="option-list"></ul>`)
        var $prevActive = false;
        quick_configuration?.list?.forEach((item) => {
            const $item = $(`<li class="item choice">
                <span class="item-content">
                    <label class="item-label">
                        <span class="label">${item?.title}</span>
                    </label>
                </span>
            </li>`)
            $optionsUL.append($item)
            $item.on("click", () => {
                if(item?.variant){
                    customizer_product?.product?.options?.forEach((option, idx) => {
                        const el = $(`variant-selects [name="${option}"]`)
                        const val = item?.variant?.["option"+(idx+1)]
                        $(`[name="${option}"][value="${val}"], [data-name="${option}"][data-value="${val}"]`).trigger("click")
                        $(`variant-selects`)[0].onVariantChange({target: el[0]})
                    })
                }else {
                    Object.keys(item?.values)?.forEach((obj) => {
                        if(PCO_VALUES?.hasOwnProperty(obj)){
                            const vItem = variantItemsAll?.[obj]?.filter((vObj) => vObj.id == item?.values[obj])?.[0]
                            if(vItem){
                                PCO_VALUES[obj] = vItem;
                            }
                        }else {
                            if(product_options?.includes(obj)){
                                const $el = $(`.product-information variant-selects fieldset input[name="${obj}"][value="${item?.values[obj]}"]`)
                                if($el[0]){
                                    setTimeout(() => {
                                        $el.siblings("label").click()
                                    }, 10);
                                }
                            }
                        }
                    })
                }
                setTimeout(() => {
                    updatePriceImage()
                }, 400);
                if($prevActive){
                    $prevActive.removeClass("active")
                }
                $item.addClass('active')
                $prevActive = $item;
                $quickConfButton.click()
            })
        })
        $quickOptions.find(".configuration-content").html($optionsUL)
        
        const hide = (f) => {
            $quickConfButton.removeClass("active")
            $quickOptions.removeClass("opened")
            bodyClickHideFunc = false
        }
        
        var isOpen = false;
        $quickConfButton.on("click", () => {
            if(isOpen){
                hide()
            }else {
                $quickConfButton.addClass("active")
                setTimeout(() => {
                    $quickOptions.addClass("opened")
                }, 300);
                bodyClickHideFunc = (e) => {
                    if(isOpen){
                        if($(e.target) != $quickConfButton && $(e.target).closest($quickConfButton).length === 0 && $(e.target).closest($quickOptions).length == 0){
                            $quickConfButton.click()
                        }
                    }
                }
            }
            isOpen = !isOpen;
        })

        
        $quickConfWrapper.append($quickOptions)
        $quickConfWrapper.children(".price-range-combine-configurable-wrap").append($quickTitle, $quickConfButton)
    }

}

var pplr_personally_check_count = 0;
var PCO_LOADED = true;
var pplr_personally_check = () => {
    pplr_personally_check_count++
    // console.log(pplr_personally_check_count, 'j;lj')
    if(pplr_personally_check_count > 1){
        if(PCO_DATA && PCO_LOADED){
            $(".product-personalizer").remove()
            $(".p_a_t_c").removeClass("p_a_t_c")
        }else {
            if(typeof window.PPLR_CAlCULATE_PRICE == "function"){
                setTimeout(() => {
                    window.PPLR_CAlCULATE_PRICE()
                }, 1000);
            }
            $("body").on("click", ".p_a_t_c", function() {
                if($(this).hasClass("pplr_adding")){
                    if(window.variant_change){
                        $(".product product-form")[0].onSubmitHandler()
                    }
                }
            })
            $(".product-information").removeClass("personally-app")
            if($("#customisation-options").length > 0){
                // $("#customisation-options").html($(".product-personalizer"))
                $("#customisation-options").remove()
            }
        }
    }
}

var start_customization = () => {
    $(document).ready(function () {

        // if(!PCO_DATA){
        //     $("#customisation-options").remove();
        //     $(".product-information").removeClass("personally-app");
        //     // pplr_personally_check();
        //     return;
        // }
        pplr_personally_check();

        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        let select_val_params = {}
        let select_val_params_def = {}
        params.forEach((value, key) => {
            const check = "c_value__"
            const check2 = "cv__"
            if(key?.includes(check)){
                select_val_params[key?.replace(check, "")] = value
            }else if(key?.includes(check2)){
                select_val_params_def[key?.replace(check2, "")] = value
            }
        });
        const recursive_check = (list) => {
            list?.length > 0 && list?.map(item => {
                if(item?.type == "engraving") {
                    return
                }
                if(item?.filter_type && select_val_params[item?.filter_type]){
                    PCO_NAME_FILTER_TYPES[item?.name] = select_val_params[item?.filter_type]
                }
                if(select_val_params_def?.[item?.name]){
                    PCO_NAME_FILTER_TYPES[item?.name] = select_val_params_def?.[item?.name]
                }
                if(item?.list?.length > 0 || item?.has_sub_item){
                    recursive_check(item?.list)
                }
            })
        }
        recursive_check(PCO_OPTIONS?.list)
        
        if(PCO_DATA?.customizer?.metadata?.top_tabs?.enabled){
            PCO_DATA?.customizer?.metadata?.top_tabs?.list?.forEach((item) => {
                if(item?.is_current && item?.type == "pair"){
                    $(".pair-ring-icon").html(`<span class="suffx-label-pair pair">Paarpreis</span>`)
                    return;
                }
            })
        }

        // const options_wrapper = 

        const $items = $("<div class='customisation-options-grid'></div>")

        PCO_DATA.conditions = {}
        try {
            PCO_DATA?.customizer?.metadata?.conditions?.list?.forEach((item) => {
                if(!PCO_DATA.conditions[item?.element]){
                    PCO_DATA.conditions[item?.element] = []
                }
                PCO_DATA.conditions[item?.element].push(item)
            })
        } catch (error) {
        }


        for (let i = 0; i < PCO_OPTIONS?.list?.length; i++) {

            const item = PCO_OPTIONS.list[i]
            const name = item?.name;

            if(item?.type == "size"){
                let $additionalItem = null;
                $additionalItem = size_item(item, item?.label); 
                const $wrapper = $('<div>').append($additionalItem);
                $items.append($wrapper);
                continue;
            }

            const $item = $('<div>', {
                class: `option-item condition-item MuiCollapse ${item?.collapsible_open ? "active" : ""}`
            });

            const $optionHead = $('<div>', { class: 'option-head collapse-action' });
            const $optionLabel = $('<div>', { class: 'option-label' });
            const $optionLabelTitle = $('<div>', { class: 'option_label_title' }).append(
                $('<span>').text(item?.label+": ")
            );
            const $valueSelected = $('<div>', { class: 'value_selected' }).text("");


            $optionLabel.append($optionLabelTitle, $valueSelected);
            if(item?.popover){
                const $popup = $(`<span data-toggle="popover" class="enable-popover"><span class="help_icon target-icon">[?] </span></span>`);
                popoverItem($popup, item?.popover)
                $optionLabel.append($popup)
            }


            const $dropdownPreview = $('<div>', { class: 'relative' }).append(
                $('<span>', { class: 'dropdown_proview sprite-bf' })
            );
            $optionHead.append($optionLabel, $dropdownPreview);
            
            const $collapseWrapper = $('<div>', {
                class: `MuiCollapse-wrapper ${item?.collapsible_open ? "visible" : ""}`
            });

            const $collapseWrapperInner = $('<div>', { class: 'MuiCollapse-wrapperInner' });
            const $optionGroupWrapper = $('<div>', { class: 'option_group_wrapper' });

            if (item?.list?.label) {
                const $groupLabel = $('<div>', { class: 'option_group_label option-main-title' })
                    .append($('<div>', { class: 'label' }).text(item?.list?.label));
                $optionGroupWrapper.append($groupLabel);
            }
            const single_types = ["engraving", "size", "choice", "color", "metal"]
            if(single_types.includes(item?.type)){
                let $additionalItem = null;
                $additionalItem = has_additional_item(item, item?.name, item?.type == "color" || item?.type == "metal", true); 
                const $wrapper = $('<div>').append($additionalItem);
                $optionGroupWrapper.append($wrapper);
            }else {
                $.each(item?.list, function (idx, el) {
                    let $additionalItem = null;
                    // const has_additional_check = 
                    if (el?.has_additional || (el?.list?.length > 0 && item?.type == "label")) {
                        $additionalItem = has_additional_item(el, name, idx == 0); 
                        const $wrapper = $('<div>').append($additionalItem);
                        $optionGroupWrapper.append($wrapper);
                    } else {
                        const $optionGroupContainer = $('<div>', { class: 'option_group_container' })
                            .append(
                                $('<div>', { class: 'option_group_label' })
                                    .append($('<div>', { class: 'label' }).text(el?.label))
                            );
                        $optionGroupWrapper.append($optionGroupContainer);
                    }
                });
            }

            $collapseWrapperInner.append($optionGroupWrapper);
            $collapseWrapper.append($collapseWrapperInner);
            $item.append($optionHead, $collapseWrapper);

            $items.append($item);

        }



        if(Object.keys(PCO_DATA?.conditions ?? {}).length > 0){
            updateConditionProperites()
            document.addEventListener("PCO_VALUES_CHANGED", () => {
                updateConditionProperites()
            })
        }
        
        const options_wrapper = $("#customisation-options")
        options_wrapper.html($items)
        $("#customisation-options").find(`[data-name]`).each(function() {
            $(this).closest(".option-item").find(".value_selected").addClass("data-value-name-"+($(this).attr("data-name").replaceAll(" ", "s__c")))
        })

        if($("#customisation-options .customisation-options-grid").children().length > 2){
            $("#product-price-mobile").addClass('visible-price')
        }

        // quick configuration
        const generateTopTabs = () => {
            const top_tabs = PCO_DATA?.customizer?.metadata?.top_tabs
            if(top_tabs?.enabled && top_tabs?.list?.length > 0){
                const $top_tabs = $(`<div class="set_product_option">
                    <div class="tabs-container">
                        <div class="tabs-warapper"></div>
                    </div>
                </div>`)
                const $tabList = $top_tabs.find('.tabs-warapper')
                top_tabs?.list?.forEach((item) => {
                    if(item?.is_current || !item?.url){
                        $tabList.append(`<span class="tab-item ${item?.is_current ? 'is-current' : ""} ${item?.type ? "has-icon "+item?.type : ""}">
                            <span>
                                <span class="icon-img"></span>
                                ${item?.title}
                            </span>
                        </span>`)
                    }else {
                        $tabList.append(`<a href="${item?.url}" class="tab-item ${item?.type ? "has-icon "+item?.type : ""}">
                            <span>
                                <span class="icon-img"></span>
                                ${item?.title}
                            </span>
                        </a>`)
                    }
                })
                $(".product-grid-container .product-gallery-sticky").prepend($top_tabs)
            }
        }
        generateTopTabs()
        
        setTimeout(() => {
            quickConfigurationSetup()
            setTimeout(() => {
                overviewDetails()
            }, 200);
            setTimeout(() => {
                expressDeliverVariants()
                recommendedVariantsGenerate()
            }, 1000);
        }, 0);


        options_wrapper.find(`[data-csrc]`).each(function () {
            if ($(this).is(":visible")) {
                $(this).attr("src", $(this).attr("data-csrc")).removeAttr("data-csrc")
            }
        })

        $("body").on("click", "#section-customization-details .mobile-expand span", function(e) {
            e.stopPropagation()
            $(this).closest(".product-detail-container").addClass("expanded")
        })
        $("body").on("click", "#detail-view-more", function(e) {
            e.stopPropagation()
            document.getElementById('section-customization-details').scrollIntoView({ behavior: 'smooth' });
        })

        for (const option_name in PCO_VALUES) {
            const variant = PCO_VARIANTS.filter((obj) => obj.id == PCO_VALUES[option_name])
            if (variant && variant[0]) {
                // PCO_VALUES[option_name] = {id: variant[0]?.id, price: variant[0]?.price, value: variant[0]?.value}
                PCO_VALUES[option_name] = variant[0]
                // if(variant[0]?.engraving_preview){
                //     PCO_VALUES[option_name].engraving_preview = variant[0]?.engraving_preview
                // }
            }
        }
        // const PCO_VALUES
        // PCO_VALUES_REF = PCO_VALUES;
        connectedVariantsValues()
        setTimeout(() => {
            updatePriceImage()
        }, 1000);


        if(!PCO_DATA){
            $("#customisation-options").remove();
            $(".product-information").removeClass("personally-app");
            // pplr_personally_check();
            return;
        }
        pplr_personally_check();

        // size carta
        const size_caret = PCO_DATA?.customizer?.metadata?.size_caret
        if(size_caret){
            let className = size_caret?.type == "caret" ? "carat" : "width"
            let suffix = size_caret?.type === "size" ? "w" : "ct"
            let val = size_caret?.type == "caret" ? size_caret?.caret : size_caret?.size
            $(".product-title-container .page-title-wrapper").append(`<span class="title-suffix ${className}">${val} ${suffix}</span>`) 
        }


        // body clcik
        $(document).on("click", function(e) {
            if(typeof bodyClickHideFunc === "function"){
                bodyClickHideFunc(e)
            }
        });

        $("body").on("click", ".delivery-product-variant.express .delivery-estimate-date", function() {
            $(this).toggleClass("active")
        })

    })

}

// window.onload = () => {
//     function getFormattedDate(daysToAdd) {
//         const currentDate = new Date();
//         currentDate.setDate(currentDate.getDate() + daysToAdd);
    
//         return currentDate.toLocaleDateString("de-DE", {
//             day: "numeric",
//             month: "short",
//         });
//     }
//     document.querySelectorAll(`[data-time-str]`).forEach((item) => {
//         const time_val = item.getAttribute("data-time-str")?.split(",");
//         const str = []
//         if(time_val[0]){
//             str.push(getFormattedDate(parseInt(time_val[0])))
//         }
//         if(time_val[1]){
//             str.push(getFormattedDate(parseInt(time_val[1])))
//         }
//         item.textContent = str.join(" - ")
//     })
// }

// window.onload = () => {
    $(document).ready(function() {



        $("body").on("click", ".MuiCollapse .collapse-action", function (e) {
            if($(e.target).closest(`[data-toggle="popover"]`).length > 0){
                return;
            }
            const $item = $(this).closest(".MuiCollapse");
            const $wrapper = $item.children(".MuiCollapse-wrapper");
        
            if ($item.hasClass("active")) {
                $item.removeClass("active");
                $wrapper.animate({ height: 0 }, 300, function () {
                    $wrapper.removeClass("visible");
                });
            } else {
                const isOptionItem = $item.hasClass("option-item");
                const $prevActive = $item.siblings(".active");
        
                $item.addClass("active");
                $wrapper.addClass("visible");
        
                const autoHeight = $wrapper.css('height', 'auto').outerHeight();
                $wrapper.css('height', 0).animate({ height: autoHeight }, 300, function () {
                    $wrapper.css('height', 'auto');
                });
        
                if (!isOptionItem) {
                    $prevActive.removeClass("active");
                    $prevActive.children(".MuiCollapse-wrapper")
                        .removeClass("visible")
                        .animate({ height: 0 }, 300);
                }
                $wrapper.find("[data-csrc]").each(function () {
                    const $this = $(this);
                    if ($this.is(":visible")) {
                        $this.attr("src", $this.attr("data-csrc")).removeAttr("data-csrc");
                    }
                });
            }
        });
        
        // $("body").on("click", '.quality-options .quality-item', function () {
        //     if (!$(this).hasClass("active")) {
        //         $(this).addClass("active").siblings().removeClass('active')
        //     }
        // })
        $("body").on("click", ".pco-variant-option, .pco-variant-option-choice .item-content", function () {
            let $this = $(this);
    
            if ($this.hasClass("item-content")) {
                $this = $this.closest(".pco-variant-option-choice");
            }
        
            const name = $this.data("name");
            const variant_id = $this.data("id");
            const price = $this.data("price");
        
            $(`.pco-variant-option[data-name="${name}"]`).removeClass("active");
            $this.addClass("active");
        
            const item = {
                id: variant_id,
                price: price
            };
        
            const engravingPreview = $this.data("engraving-preview");
            if (engravingPreview) {
                item.engraving_preview = engravingPreview;
            }
    
            if ($this.attr("data-type")) {
                item.type = $this.attr("data-type");
            }
            if ($this.hasClass("has-preview-image")) {
                item.has_image = true;
            }

            if($this.hasClass("has-variant-connection")){
                const variantOptionName = $this.attr('data-variant-option');
                const value = $this.attr('data-value');
                const $fiedlset = $(`fieldset[data-variant-option-name="${variantOptionName}"]`)
                $fiedlset.find(`input[name="${variantOptionName}"]`).prop("checked", false)
                const el = $fiedlset.find(`input[name="${variantOptionName}"][value="${value}"]`)
                el.prop("checked", true)
                $fiedlset.closest('variant-selects')[0].onVariantChange({target: el[0]})
            }

            PCO_VALUES[name] = item
            // updatePriceImage();
        });
        
        $("body").on("click", ".option-list .item:not(.variant-item-choice) .item-label", function () {
            const item = $(this).closest(".item")
            if (item.hasClass("active")) {
            } else {
                item.addClass("active").siblings().removeClass("active")
                item.find(`[data-csrc]`).each(function () {
                    if ($(this).is(":visible")) {
                        $(this).attr("src", $(this).attr("data-csrc")).removeAttr("data-csrc")
                    }
                })
            }
        })
        $("body").on("click", '.engraving-group .font-item', function () {
            PCO_VALUES['font'] = $(this).attr("data-font")
            PCO_VALUES['font_id'] = $(this).attr("data-id")
            $(this).addClass("active").siblings().removeClass("active")
            $(this).closest(".engraving-group").find(".engraving-preview svg, .engraving-preview .engraving-preview-content").css("font-family", PCO_VALUES.font)
        })
    
        $("body").on("click", '.engraving-group .symbol-item', function () {
            const input = $(this).closest(".engraving-input").find("input")
            input.val(input.val() + $(this).attr("data-icon"))
            update_engraving(input)
        })
        $("body").on("input", '.engraving-group .engraving-input-field', function () {
            update_engraving($(this))
        })

        $("body").on("click", ".open-deliver-date-modal", function(){
            $modalContents = $(`<div class="content_popup_ship">
                <p style="padding-top: 20px;">Dieser Artikel wird speziell für Sie hergestellt, basierend auf den von Ihnen ausgewählten Produktoptionen. Ihre Bestellung wird sobald Ihre Zahlung abgeschlossen ist bearbeitet.</p>
                <p>Bitte beachten Sie, dass die voraussichtliche Lieferzeit automatisch auf der Grundlage der Produktionszeit und der ungefähren Versanddauer berechnet wird. Der tatsächliche Liefertermin kann je nach Versandort variieren.</p>    
            </div>`)
            modalItem("Voraussichtliche Zustellung", $modalContents, false, "modal-mobile-swipe")
        })
    })
// }


var necklaceItemWrapper = (item) => {
    const $wrapper = $(`<div class="necklace-item-wrapper ${item?.type ?? ""}">
        <div class="label-wrapper">
            <label class="label" for="${item?.id}"><span>${item?.label}</span><span class="label-sub"></span></label>
            <div class="label-right"></div>
        </div>    
        <div class="necklace-item-content"><div>
    </div>`)

    return $wrapper
}
var conditionUpdate = (item, $wrapper) => {
    const updateCondition = () => {
        var allOkay = true;
        for(let i = 0; i < item?.conditions?.length; i++){  
            const condItem = item?.conditions[i]
            const fieldIdx = PCO_OPTIONS?.findIndex((obj) => obj.id == condItem?.field_id)
            let value = condItem?.fieldIdx
            if(PCO_OPTIONS?.[fieldIdx]?.type == "checkbox"){
                value = value == "checked" ? true : false
            }
            if(PCO_VALUES[condItem?.field_id] != condItem?.value){
                allOkay = false;
                break;
            }
        }
        if(allOkay){
            $wrapper.show()
        }else {
            $wrapper.hide()
        }
    }
    if(item?.conditions){
        updateCondition()
        document.addEventListener("PCO_VALUES_CHANGED", () => {
            updateCondition()
        })
    }

}
var inputField = (item) => {
    const $wrapper = necklaceItemWrapper(item)
    const $inputDiv = $(`<div class="input-wrapper"></div>`)
    const $input = $(`<input id="${item?.id}" type="text" name="properties[${item?.label}]" class="necklace-input" placeholder="${item?.placeholder ?? ""}" />`)
    $inputDiv.html($input)
    $wrapper.find(".necklace-item-content").html($inputDiv)

    $input.on("keyup", () => {
        PCO_VALUES[item?.id] = $input.val()
    })

    conditionUpdate(item, $wrapper)

    return $wrapper;
}
var textareaField = (item) => {
    const $wrapper = necklaceItemWrapper(item)
    const $inputDiv = $(`<div class="input-wrapper"></div>`)
    const $input = $(`<textarea id="${item?.id}" type="text" name="properties[${item?.label}]" class="necklace-input" placeholder="${item?.placeholder ?? ""}" />`)
    $inputDiv.html($input)
    $wrapper.find(".necklace-item-content").html($inputDiv)

    $input.on("keyup", () => {
        PCO_VALUES[item?.id] = $input.val()
    })

    return $wrapper;
}
var checkboxField = (item) => {
    const $wrapper = necklaceItemWrapper(item, "checkbox")
    const $inputDiv = $(`<div class="input-wrapper"></div>`)
    const $input = $(`<input id="${item?.id}" type="checkbox" name="properties[${item?.label}]" class="necklace-input" placeholder="${item?.placeholder ?? ""}" />`)
    $inputDiv.html($input)
    $wrapper.find(".necklace-item-content").html($inputDiv)

    $input.on("change", () => {
        PCO_VALUES[item?.id] = $input.is(":checked")
    })
    return $wrapper;
}
var optionField = (item) => {
    const $wrapper = necklaceItemWrapper(item)
    const $inputDiv = $(`<div class="input-wrapper"></div>`)
    const $input = $(`<select id="${item?.id}" name="properties[${item?.label}]" class="necklace-input" placeholder="${item?.placeholder ?? ""}">`)

    const update = () => {
        PCO_VALUES[item?.id] = $input.val()
    }

    item?.list?.forEach((option, idx) => {
        $input.append(`<option ${idx == 0 ? "selected" : ""} value="${option?.label}">${option?.label}</option>`)
    })
    $inputDiv.html($input)
    $wrapper.find(".necklace-item-content").html($inputDiv)    
    
    update()
    $input.on("change", () => {
        PCO_VALUES[item?.id] = $input.val()
    })

    return $wrapper;
}


var start_necklace_customization = () => {
    $(document).ready(function() {

        const $items = $("<div class='customisation-options-grid'></div>")

        PCO_OPTIONS?.forEach((item) => {
            let $item;
            if(item?.type == "single_line"){
                $item = inputField(item);
                $items.append($item)
            }if(item?.type == "multi_line"){
                $item = inputField(item);
                $items.append($item)
            }else if(item?.type == "dropdown"){
                $item = optionField(item);
            }else if(item?.type == "checkbox"){
                $item = checkboxField(item);
            }
            $items.append($item)
        })

        const options_wrapper = $("#customisation-options")
        options_wrapper.html($items)

    })
}

// fetch('./data.json')
var pplr_app_initiated = false;
var url_type = customizer_product?.type;
if(url_type == "ring" || url_type == "necklace"){
    start_customization()
    // fetch(CUSOMIZATION_BASE_URL + `/api/${url_type}-product/` + customizer_product?.id+"?v=1")
    // .then((response) => response.json())
    // .then((json) => {
    //     PCO_DATA = json
    //     PCO_OPTIONS = json?.customizer?.options;
    //     PCO_IMAGES = json?.customizer?.images
    //     PCO_VARIANTS = json?.customizer?.variants
    //     start_customization()
    // }).catch((error) => {
    //     console.error(error)
    //     PCO_LOADED = false;
    //     start_customization()
    //     if(pplr_app_initiated){
    //         pplr_personally_check();
    //     }
    //     $(document).ready(function() {
    //         quickConfigurationSetup()
    //         setTimeout(() => {
    //             overviewDetails()
    //         }, 200);
    //     })
    // });
}else {
    PCO_LOADED = false;
    if(template_type == "product" || template_type?.includes('product.')){
        start_customization()
        $(document).ready(function() {
            quickConfigurationSetup()
            start_customization()
            setTimeout(() => {
                overviewDetails()
            }, 200);
        })
    }
}

window.addEventListener('pplrAppInitiated' , function(e) {
    pplr_app_initiated = true;
    pplr_personally_check()
})